var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoverBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 274.905,
    height: 132.007,
    viewBox: "0 0 274.905 132.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.308,
    y1: 0.25,
    x2: 0.907,
    y2: 1.488,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8957e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#ec8573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1625b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.279,
    y1: 0.181,
    x2: 0.953,
    y2: 0.666,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69aac0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#427391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.735,
    y1: 0.309,
    x2: 0.735,
    y2: 0.12,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.696,
    y1: 0.299,
    x2: 0.696,
    y2: 0.078,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.685,
    y1: 0.681,
    x2: 1.861,
    y2: 0.681,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1.088,
    y1: -1.112,
    x2: 1.639,
    y2: -1.112,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8957e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f6937c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#f08b77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e67d6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#d76a60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1625b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffad04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ffab04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#ff9901"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.001,
    y1: 0.499,
    x2: 1,
    y2: 0.499,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffad04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.042,
    y1: 0.587,
    x2: 0.921,
    y2: 0.441,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.004,
    y1: 0.701,
    x2: 0.933,
    y2: 0.365,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.002,
    y1: 0.496,
    x2: 1,
    y2: 0.496,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.087,
    y1: 0.315,
    x2: 0.789,
    y2: 0.607,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.004,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0,
    y1: 0.5,
    x2: 1.002,
    y2: 0.5,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0,
    y1: 0.496,
    x2: 1,
    y2: 0.496,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0,
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#427391"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69aac0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    y1: 1.001,
    y2: 0,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0,
    y1: 0.48,
    x2: 1,
    y2: 0.48,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.5,
    y1: 0.999,
    x2: 0.5,
    y2: -0.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#88687f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fde7da"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: -0.001,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 0.92,
    y1: 0.087,
    x2: 0.139,
    y2: 0.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d291a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b44862"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2007.i511.004_furniture_delivery_flat_Converted_",
    "data-name": "2007.i511.004_furniture_delivery_flat [Converted]",
    transform: "translate(0 -12.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M274.937,169.237v33.845H140.473v-6.07a1.551,1.551,0,0,0-1.551-1.554h-16v-6.07a1.554,1.554,0,0,0-1.554-1.551h-16v-6.084a1.551,1.551,0,0,0-1.554-1.554h-16v-6.055a1.551,1.551,0,0,0-1.554-1.551h-16v-6.069a1.554,1.554,0,0,0-1.551-1.554h-16V158.9a1.554,1.554,0,0,0-1.554-1.551h-16v-6.07a1.554,1.554,0,0,0-1.554-1.547h-16v-6.077a1.551,1.551,0,0,0-1.554-1.551H.05V102.94l2,.917,19.371,8.879,123.283,56.486Z",
    transform: "translate(-0.032 -65.05)",
    opacity: 0.25,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_649",
    "data-name": "Rectangle 649",
    width: 134.465,
    height: 2.008,
    transform: "translate(140.441 136.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_651",
    "data-name": "Rectangle 651",
    width: 274.887,
    height: 6.732,
    transform: "translate(0.018 138.028)",
    fill: "#ffc39f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M14.6,381.27.313,388H.05v-.245l13.841-6.487Z",
    transform: "translate(-0.032 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M87.271,381.27,75.848,388H75.06l11.5-6.732Z",
    transform: "translate(-48.055 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M160.883,381.27,152.332,388h-.792l8.635-6.732Z",
    transform: "translate(-97.019 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M234.5,381.27,228.808,388h-.788l5.771-6.732Z",
    transform: "translate(-145.983 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M308.112,381.27,305.288,388H304.5l2.9-6.732Z",
    transform: "translate(-194.947 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M381.768,388h-.788l.04-6.732h.709Z",
    transform: "translate(-243.911 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M453.212,388h-.788L449.6,381.27h.709Z",
    transform: "translate(-287.842 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M524.6,388h-.788l-5.688-6.732h.705Z",
    transform: "translate(-331.71 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M595.973,388h-.791l-6.857-5.4-1.695-1.335h.709l1.713,1.335Z",
    transform: "translate(-375.572 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M667.357,388h-.788l-3.447-2.033-5.71-3.364-2.263-1.335h.705l2.281,1.335,5.519,3.231Z",
    transform: "translate(-419.439 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M738.206,387.757V388h-.263L723.66,381.27h.705Z",
    transform: "translate(-463.301 -243.242)",
    fill: "#ffe7d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M86.6,87.581V139.3h-2V86.66Z",
    transform: "translate(-54.163 -54.627)",
    fill: "#8e344e",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M460.194,228.971l.05-.05c.065-.076.133-.148.2-.223A2.515,2.515,0,0,1,460.194,228.971Zm1.6-1.77h0l.227-.266Zm10.239,56.9h.119a3.542,3.542,0,0,0,.036-1.644,5.452,5.452,0,0,0-.241-.917,5.1,5.1,0,0,0-.835-1.079h-6.559a6.538,6.538,0,0,1-2.695,2.008,11.813,11.813,0,0,1-4.62.849.72.72,0,0,0,.1.8h.122a.209.209,0,0,0-.212.212.212.212,0,0,0,.212.212h14.575a.218.218,0,1,0,0-.435Zm-4.317-3.6h-.032Zm-5.677-53.582-.245.281h0Zm-1.6,1.777c-.083.094-.165.183-.252.273l.05-.05C460.309,228.845,460.381,228.773,460.446,228.7Zm-70.1,53.759h7.178v-2.008H390.35Z",
    transform: "translate(-249.909 -144.424)",
    fill: "#8e344e",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M210.285,104.96l.05-.05c.065-.076.133-.148.2-.223A2.515,2.515,0,0,1,210.285,104.96Zm13.258,41.418a15.113,15.113,0,0,0-.817-4.148s.417-14.564-.4-18.874l-.511-.953-.173-.327-.324-.6-.259-.482-.04-.072h0l-.72-7.264a12.152,12.152,0,0,0,.425-1.457c.1-.5.144-7.4-.13-11.873a9.394,9.394,0,0,0-1.3-4.22l-.273-.461s-.155-.961-.313-2.285c-.155-1.259-.313-2.842-.36-4.242a.786.786,0,0,1,.04-.158h0c.029-.108.054-.216.083-.324.09-.36.173-.684.248-1a.694.694,0,0,1,0-.072s0-.018,0-.025.018-.068.025-.1c.025-.112.05-.219.072-.324l.022-.086a1.193,1.193,0,0,1,.054-.255h.281a26.031,26.031,0,0,0,.759-5.8,9.66,9.66,0,0,0-.882-4.443,6.994,6.994,0,0,0-.856-1.691h.09l-.5-1.025s-.2-.061-.532-.137a25.228,25.228,0,0,1-1.238-2.234,1.224,1.224,0,0,0-.137-.043,7.7,7.7,0,0,1-.2-2.921l.166.112c2.126-1.921,1.9-3.4,1.885-3.483h0l.72-1.022a3.72,3.72,0,0,0-1.079-3.828c-1.5-1.45-4.015-1.507-4.735-1.493a2.623,2.623,0,0,0-1.259.407,3.274,3.274,0,0,0-1.252,1.439l-.032.076c-.932-.166-2.285-.3-3.4-.389s-2-.144-2-.144c0,.058.378,1.867,1.385,2.367a17.931,17.931,0,0,0,3.4.327l-.108.443a3.068,3.068,0,0,1-.054.479.274.274,0,0,1-.022.126c-.022.047,0,.1-.025.151s0,.025,0,.04a.331.331,0,0,1-.025.137,12.026,12.026,0,0,1-.579,2.044,21.186,21.186,0,0,0,.324,3.414l.5.112s.514-.094,1.284-.27l-.029.453-.061.867a2.355,2.355,0,0,0,.389.1,3.885,3.885,0,0,1,.094,1.392l-.14.047v.7c-1.328,2.033-4.015,6.994-4.051,7.063l-.27-.058a6.057,6.057,0,0,1-.36.784h0c-.086-.043-.166-.079-.227-.115a5.22,5.22,0,0,0-.809,2.878l-.1.133-.169.23-.27.36-.043.054c-.4.547-.928,1.418-1.281,2.018l-.385.662-.8.162s-3.321,2.187-7.94,4.548c-1.838.939-3.882,1.9-6.008,2.767l-.428.176a1.8,1.8,0,0,0-.259-.32,3.548,3.548,0,0,1-.72.23,22.777,22.777,0,0,0-1.723-8.714h0a18.243,18.243,0,0,0-.878-1.8,4.573,4.573,0,0,0-1.015-1.324q-1.376-1.318-2.878-2.493h0l-.514-.407-.018-.018q-.827-.651-1.878-1.439l-.025-.018c-.212-.162-.432-.324-.662-.493l-.126-.094-.64-.457-.144-.1-.72-.514-.09-.065q-.842-.6-1.8-1.252l-.144-.1-.8-.547-.248-.166c-.252-.169-.5-.36-.766-.514l-.273-.18-.856-.565-.212-.14q-1.108-.72-2.324-1.493L167.9,71.6l-.961-.615-.36-.227-.935-.576-.392-.241-1.04-.63-.32-.194q-1.4-.838-2.918-1.723l-.36-.205-1.18-.684-.2-.112-.36-.2-.831-.475-.5-.284-.975-.547-.13-.072a.054.054,0,0,0-.025,0l-1.928-1.079-.1-.05-.986-.54-.1-.054-1.828-.982-.331-.176-.932-.5-.381-.2-1.558-.817-.612-.317-.828-.428c-.36-.194-.748-.385-1.126-.579l-.831-.41-.964-.5-.64-.324-1.518-.766-.435-.216c-.486-.241-.975-.486-1.471-.72l-.3-.151-1.565-.763-.3-.144-.18-.09-.608-.281-1.051-.5-.8-.385-.9-.425-.212-.1-1.061-.5-.878-.41-1.461-.68-1.209-.561-1-.457-.993-.453-1.043-.482-1.3-.586-1.547-.691-.957-.425-1.184-.536-.914-.4q-1.079-.471-2.159-.939l-.871-.36-1.3-.558-.925-.4-1.3-.554-1.925-.81-1.205-.5-1.2-.511-1.126-.468-1.921-.788-.4-.165a4.9,4.9,0,0,0-4.465,8.7,13.313,13.313,0,0,0,2.378,1.079,12.694,12.694,0,0,1,1.554,6.749c-2.562-.781-4.753-1.418-5.537-1.572-.3-1.392-.568-2.81-.77-3.806a3.555,3.555,0,0,0-.18-.482.065.065,0,0,0,0-.022,8.725,8.725,0,0,0-1.029-2.849c-.054-.079-.112-.155-.169-.23h0a2.4,2.4,0,0,0-.36-.36l-.058-.05-.047-.029h-.018l-.061-.043-.05-.025-.058-.032H97.17l-.137-.061h0L96.914,48h0a19.285,19.285,0,0,1-1.389-1.8l-.32.029a20.585,20.585,0,0,1-.831-3.029,2.216,2.216,0,0,1-.205-.277,2.225,2.225,0,0,0,.209.277.2.2,0,0,1,0-.05c.209-.637.579-.986,1.615-1.838a7.851,7.851,0,0,0,.36-3.565,5.641,5.641,0,0,0-2.087-3.569.655.655,0,0,1,.032-.9,1.079,1.079,0,0,0-.622.36.6.6,0,0,1-.112-.36l-.259.522a27.557,27.557,0,0,0-3.673.5,2.4,2.4,0,0,1-1.777-.331h0c0,.029,0,.32.493.59a2.047,2.047,0,0,1-1.867-1.342,2.828,2.828,0,0,0,1.507,2.641,1.8,1.8,0,0,1-1.382-.669,3.281,3.281,0,0,0,1.482,1.558,6.393,6.393,0,0,0,.094,1.162.154.154,0,0,0,0,.043,10.765,10.765,0,0,1-1.392,1.522.349.349,0,0,0,.076.579l.36.173a9.415,9.415,0,0,0,.479,2.979l-.41.622.594.691,1.59-.425s.108.068.187.385a4.317,4.317,0,0,1,.05,1.27,2.159,2.159,0,0,0,.91.594l.363,1.187-.1.068h-.025l.133.594s-.615,1.162-1.324,2.659a29.8,29.8,0,0,0-1.835,4.677h0a.335.335,0,0,0-.36.241c-1.349,4.954,1.6,11.513,1.6,11.513l.309,2.187a2.281,2.281,0,0,0,.594,1.241,9.97,9.97,0,0,0,.921,1.749,9.282,9.282,0,0,1,.86,1.946l-.317.637c-.2.4-.482.953-.828,1.63-.173.338-.36.72-.565,1.079L0,36.555l.018,1.95,30.42,13.942,2,.921L81.08,75.656V94.091c-.36.72-.554,1.141-.554,1.141v1.856a13.107,13.107,0,0,0-.475,2.8c.115.417.489,1.439,1.029,2.817v25.253H77.407v-6.066a1.554,1.554,0,0,0-1.551-1.554h-16v-6.07a1.554,1.554,0,0,0-1.554-1.551h-16v-6.07a1.554,1.554,0,0,0-1.554-1.554h-16v-6.07A1.551,1.551,0,0,0,23.2,97.473H7.2v59.1H140.441v-.14h7.178V152.38a1.551,1.551,0,0,0-1.547-1.554h-16v-6.066a1.554,1.554,0,0,0-1.554-1.554h-16v-6.07a1.554,1.554,0,0,0-1.554-1.554h-1.079a.158.158,0,0,0-.144-.126h0a4.2,4.2,0,0,0-.464-2.911,7.444,7.444,0,0,1-.824-1.248c.439-.137.917-.3,1.439-.475.047-.18.094-.36.137-.529s.076-.327.115-.489c.022-.1.047-.2.068-.3q.126-.55.216-1.079a17.591,17.591,0,0,0-.669-9.829c.36-6.566-.076-17.654-.389-18.77a5.724,5.724,0,0,0-1.421-2.457c0-.813-.144-2.518-.317-4.109-.072-.658-.144-1.3-.212-1.86-.094-1.051-.2-1.77-.2-1.77l.7-.245v-.2l.543.061.694-.72,7.53,3.45,15.024,7.955V150.75h2V101l35.424,18.752-1.752,3.339,2.133,1.13.583-.655,2-2.245,8.35,4.422-1.767,3.332,1.633.853.5.263.583-.655,1.7-1.907.3-.338,1.439.77c.943-1.346,1.885-2.594,2.824-3.76a52.689,52.689,0,0,1,13.215-11.966l-.281,1.123.561.176.36-.309.648.191.324-.2h.428l.263-.284a8,8,0,0,0,1.18-.921c.529-.522.91-1.727,1.864-2.551a3.639,3.639,0,0,0-.137-.4c.36-.36,1.4-1.338,2.666-2.634l.155-.155-.151.155a.517.517,0,0,0,.025.194h0v.061l-.036-.043s.23,5.645.148,8.045l.547.662s.827,4.015.9,5.123a4.562,4.562,0,0,0,.335,1.061,16.117,16.117,0,0,0-.094,2.036,21.362,21.362,0,0,1,.982,3.314c.248,1.241,2.738,22.968,2.612,26.264l-.428,1.079s.309,1.022.486,1.475a1.659,1.659,0,0,0,.608.327,3.048,3.048,0,0,1-.176.255l-.036.047h6.559a2.3,2.3,0,0,1-.3-.482c.457-.119.874-.234,1.176-.32l.489-.14s1.3-6.059.986-9.1ZM216.4,64.442a.428.428,0,0,0,.047.122.353.353,0,0,0-.05-.122ZM95.094,38.761v.022a.122.122,0,0,1,0-.036.022.022,0,0,1,0,.014ZM90.23,55.483ZM95.1,48.158Zm-3.842-.784Zm.489-.259.061-.029h0ZM83.084,76.577l6.116,2.8c-1.1,2.072-2.414,4.49-3.691,6.631-.925,1.54-1.738,2.983-2.429,4.245Zm0,50.247V107.616a108.387,108.387,0,0,0,4.961,10.434c-.194,2.853-.2,2.781.083,3.238a20.25,20.25,0,0,0,1.669,1.8h.626S88.485,126.22,83.084,126.824Zm21.058,4.537c-.863.975-3.13,2.965-7.519,3.285-.335.054.13.813.13.813h0a.155.155,0,0,0-.144.126H94.946v-6.073A1.551,1.551,0,0,0,93.73,128h1.86a.155.155,0,0,0,0-.306h0a4.2,4.2,0,0,0-.464-2.911,8.332,8.332,0,0,1-1.051-1.695h.907a32.561,32.561,0,0,0-.421-5.328c-1.194-.691-1.475-.81-1.475-.81h0c-.05-.324-1.677-10.707-1.716-11.822a13.588,13.588,0,0,0-2.306-7.3c1.623-1.932,3.368-3.749,3.368-3.749v-.72l4.76-4.317c.058.144.115.3.173.446l.029.072c1.5,3.932,3.087,8.635,3.087,8.635l.054,2.349a7.515,7.515,0,0,1,.5,1.576,86.643,86.643,0,0,1,1.194,9.113l-.151,1.731c1.194,3.6,1.9,15.981,1.9,15.981l-.554,1.662a4.758,4.758,0,0,0,.694.72l.133.108A1.254,1.254,0,0,1,104.142,131.361Zm.273.205a2.472,2.472,0,0,0,.3.173,2.07,2.07,0,0,1-.3-.176ZM204.73,107.821a1.859,1.859,0,0,0-.4-.1,3.827,3.827,0,0,1-.54.72,2.947,2.947,0,0,0-1.551-2.159,4.677,4.677,0,0,0-1.612-.507h0l-14.265-4.875a35.64,35.64,0,0,0,.446-3.547,4.5,4.5,0,0,1,1.252-.306,3.323,3.323,0,0,0,.119-.4c.514-.068,1.921-.263,3.709-.568,3.6-.619,8.692-1.687,11.178-3.1l.989-1.263,1.317-.176c.162-.025.72-.946.72-.946l.518-.4.05-.04.464,2.493s-.173,2.126-.14,2.738l.831,1.619s.223,2.731.4,4.677a68.139,68.139,0,0,1-3.5,6.152Zm6.379-12.333c.076-.18.144-.36.212-.507C211.256,95.138,211.192,95.311,211.109,95.487Zm.8,7.689h0l.245-.281Zm.083-9.847s-.086.23-.259.651l-.162.4q.086-.219.162-.4l.255-.655.173-.183Zm.964-7.465-.079-.029.079.025.1.036Zm-.6-13.9-.536.162c.162-.05.342-.108.536-.162.255-.076.532-.155.82-.227-.291.076-.568.155-.824.227Zm1.079,14.049h0Zm.489.14-.083-.025.083.022.1.029Zm1.184-19.234Zm.022,0c.036-.029.119-.086.223-.169-.115.072-.2.13-.234.155Zm2.238,7.717-.058-.029.058.025.162.086Z",
    transform: "translate(0 -20.414)",
    fill: "#8e344e",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956",
    transform: "translate(205 138.028)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M714.385,388l-.245-5.4.018-1.335H718.6l0,.158.014.338.23,6.235Z",
    transform: "translate(-662.206 -381.27)",
    fill: "#c596a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M579.68,390.377l.1-5.4h48.276l.245,5.4Z",
    transform: "translate(-576.122 -383.645)",
    fill: "#9e5067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M692.759,399.826h-.112l-.007-.086Z",
    transform: "translate(-648.441 -393.095)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M630.53,399.74l.119.086h-.112Z",
    transform: "translate(-608.677 -393.095)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M628.056,384.98l-12.718,3.231-.532.133-8.005,2.033H579.68l.1-5.4Z",
    transform: "translate(-576.122 -383.645)",
    fill: "#842f47",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M628.219,381.27H579.9l.022,1.335H628.2Z",
    transform: "translate(-576.263 -381.27)",
    fill: "#64323a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M573.427,381.27,573.305,388H569.79l.252-6.732Z",
    transform: "translate(-569.79 -381.27)",
    fill: "#c596a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M578.6,382.6l-.1,5.4h-.666l.151-6.732h.594Z",
    transform: "translate(-574.937 -381.27)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M715.111,388h-.727l-.245-5.4.018-1.335h.666Z",
    transform: "translate(-662.206 -381.27)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M574.791,381.27,574.669,388H571.92l.137-6.732Z",
    transform: "translate(-571.154 -381.27)",
    fill: "#8e344e",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M714.385,388l-.245-5.4.018-1.335h1.626l.3,6.732Z",
    transform: "translate(-662.206 -381.27)",
    fill: "#8e344e",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M623.359,68.61,619.207,181.1h-4.443l-.018-1.335,4.767-106.225H564.467l-2.7-2.385h0L558.89,68.61Z",
    transform: "translate(-357.812 -43.071)",
    fill: "#c596a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M624.663,188.535H576.388L574.38,82.31h55.054Z",
    transform: "translate(-367.729 -51.842)",
    fill: "#9e5067"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M655.566,165.451l-.446.648.763-61.738,1.022,1.673Z",
    transform: "translate(-419.42 -65.959)",
    fill: "#842f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M698.91,163.334l.928,1.454,3.13-63.307-1.382,2.709Z",
    transform: "translate(-447.455 -64.115)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M655.12,274.321l16.683.533-.928-1.454-15.309.273Z",
    transform: "translate(-419.42 -174.181)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M655.608,320.107l-.417-21.029h14.974l.576-.507-16.51-.691.6,23.141Z",
    transform: "translate(-418.85 -189.854)",
    fill: "#842f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M694.756,300.307l-2.116,22.159.687-.5,2-22.166Z",
    transform: "translate(-443.441 -191.083)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M594.529,166.04l-1.079-57.925v-.166h.137l13.934-.36h.428v.536l-1.569,57.828v.144h-.14C602.344,166.087,598.429,166.065,594.529,166.04Zm.176-.209c3.86-.025,7.7-.043,11.549-.043l-.13.144,1-57.835.41.522-13.927-.36.137-.173Z",
    transform: "translate(-379.938 -68.027)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M607.36,323.9H596.47l-.95-20.284h13.1Zm-10.66-.273h10.434l1.216-19.723H595.783Z",
    transform: "translate(-381.263 -193.529)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M589.683,164.036l-.428.648-.745-62.534,1.241,1.45Z",
    transform: "translate(-376.775 -64.544)",
    fill: "#842f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M634.29,163.334l.968,1.454,1.356-63.307-1.1,1.036Z",
    transform: "translate(-406.084 -64.115)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M590.58,274.321l16.694.533-.968-1.454-15.3.273Z",
    transform: "translate(-378.1 -174.181)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M593.335,321.336l-1.007-21.029H607.3l.558-.507H591.91l.669,22.45Z",
    transform: "translate(-378.952 -191.083)",
    fill: "#842f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M632.027,300.307l-1.5,22.159.676-.5,1.378-22.166Z",
    transform: "translate(-403.677 -191.083)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M579.586,82.31l17.014,99.1,28.063,7.124H576.388L574.38,82.31Z",
    transform: "translate(-367.729 -51.842)",
    fill: "#842f47",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M683.58,109.01l1.907,57.835h1.752l2.9-57.835Z",
    transform: "translate(-437.641 -68.936)",
    fill: "#842f47",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M686.22,304.06l.457,20h1.015l1.8-20Z",
    transform: "translate(-439.331 -193.81)",
    fill: "#842f47",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M670.558,323.9H659.668l-.378-20.284h13.092Zm-10.65-.273h10.434l1.767-19.723H659.546Z",
    transform: "translate(-422.09 -193.529)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M661.16,166.04l.565-57.925v-.166h.137l13.945-.36h.424l-.018.507-3.188,57.828v.144H672.9C668.974,166.087,665.06,166.065,661.16,166.04Zm.183-.209c3.857-.025,7.7-.043,11.549-.043l-.133.144,2.616-57.835.4.522-13.916-.36.14-.173Z",
    transform: "translate(-423.287 -68.027)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M588.51,101.721l18.795-.241-1.1,1.036-16.456.655Z",
    transform: "translate(-376.775 -64.115)",
    fill: "#842f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M628.219,378.895H579.9l.022-1.335H628.2Z",
    transform: "translate(-371.263 -240.867)",
    fill: "#64323a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M566.455,181.1H563.07L558.9,68.61l2.871,2.54,2.7,2.389Z",
    transform: "translate(-357.818 -43.071)",
    fill: "#c596a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M558.88,68.963l5.6,4.8-.025-.227h.292l-5.332-4.929h-.529Z",
    transform: "translate(-357.805 -43.071)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M726.9,73.539l3.756-4.929h.266l-.022.59-3.817,4.576,0-.237Z",
    transform: "translate(-465.375 -43.071)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M571.55,80.46l2.411,108.226h.594l.022-1.335-1.982-106Z",
    transform: "translate(-365.917 -50.658)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M718.914,81.869l.518-.619-4.609,107.942h-.662l-.022-1.335Z",
    transform: "translate(-457.206 -51.163)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M571.046,185.619h-2.731L566.07,75.706l.291-.036,2.7,2.389Z",
    transform: "translate(-362.409 -47.591)",
    fill: "#8e344e",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M626.34,77.4l-4.828,108.226h-1.626l-.018-1.335,4.767-106.225H569.588l-2.7-2.385h0Z",
    transform: "translate(-362.934 -47.597)",
    fill: "#8e344e",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M712.551,201.755l.162,9.937a.237.237,0,0,1-.223.259h-2.626a.245.245,0,0,1-.23-.259l-.144-9.937a.241.241,0,0,1,.223-.255h2.609a.245.245,0,0,1,.23.255Z",
    transform: "translate(-454.228 -128.15)",
    fill: "#bce4ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M709.549,211.952h-.191a.252.252,0,0,1-.234-.259L709,201.755a.234.234,0,0,1,.223-.255h.183a.237.237,0,0,0-.223.255l.144,9.937A.245.245,0,0,0,709.549,211.952Z",
    transform: "translate(-453.913 -128.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M707.974,210.833l-.061.291-.137.684-2.205.054-2.152.058-.209-1.259Z",
    transform: "translate(-450.208 -134.014)",
    fill: "#cfecff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M712.177,211.954l-.2.975-2.205.054,0-.3,2.205-.054.137-.684Z",
    transform: "translate(-454.408 -134.84)",
    fill: "#96cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M702.391,210.66h-.461l.385,1.259h.281Z",
    transform: "translate(-449.389 -134.014)",
    fill: "#96cdec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M713.757,218.451a.277.277,0,1,0-.551,0,.31.31,0,0,0,.166.281l-.079.468a.036.036,0,0,0,.032.043h.309a.04.04,0,0,0,.027-.014.039.039,0,0,0,.009-.029l-.083-.468a.306.306,0,0,0,.169-.281Z",
    transform: "translate(-456.607 -138.805)",
    fill: "#2b4250"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M646.875,120c.165.842-.766,1.731-2.08,1.99s-2.518-.216-2.677-1.054.766-1.731,2.079-1.99S646.709,119.156,646.875,120Z",
    transform: "translate(-411.085 -75.25)",
    fill: "#842f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M646.335,119.51c.166.838-.766,1.727-2.079,1.986s-2.518-.216-2.677-1.054.766-1.731,2.08-1.986S646.173,118.668,646.335,119.51Z",
    transform: "translate(-410.739 -74.939)",
    fill: "#c596a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M559.948,157.169l-.234-.158c-.1-.072-.245-.169-.406-.291l-.072-.054-.054-.04-.1-.079-.112-.086-.058-.047-.094-.076-.137-.112-.14-.112-.065-.054-.094-.083-.079-.065-.072-.065-.083-.072-.083-.072c-.047-.043-.094-.083-.14-.13s-.148-.13-.219-.2l-.111-.1-.115-.108q-.115-.108-.227-.227l-.158-.158-.072-.076-.151-.158h0l-.13-.14-.14-.155c-.094-.1-.183-.205-.277-.313l-.076-.094c-.054-.061-.1-.122-.155-.187a.756.756,0,0,1-.068-.083l-.086-.108v-.018l-.1-.13-.043-.054v-.018h0l-.025-.032-.032-.043h0l-.115-.151-.112-.155-.061-.086-.05-.072c-.032-.043-.065-.09-.094-.137l-.129-.191c-.036-.054-.068-.108-.1-.158l-.259-.417c1.115-1.943,3.637-5.627,4.087-6.231a5.534,5.534,0,0,1,3.529-1.407,8.53,8.53,0,0,1,1.184-.029c.378.022,1.439,1.015,1.99,2.112.029.054.054.108.079.165a2.9,2.9,0,0,1,.266.95,5.83,5.83,0,0,1-.054,1.439h0C565.578,150.557,564.377,153.3,559.948,157.169Z",
    transform: "translate(-355.2 -91.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M559.731,157.151a.119.119,0,0,1-.05,0l-.241-.162c-.1-.072-.245-.169-.41-.291l-1.277-1.047-.115-.1-.223-.2-.234-.23-.23-.227-.158-.162-.227-.234-.137-.151h-.018l-.122-.133-.277-.317-.079-.094c-.05-.061-.1-.122-.155-.187l-.155-.194-.018-.022-.1-.126-.032-.043V153.2h0l-.029-.036-.029-.036h0l-.112-.155-.115-.155-.112-.158a1.6,1.6,0,0,1-.1-.14l-.13-.191-.1-.158c-.09-.137-.176-.277-.263-.421a.1.1,0,0,1,0-.1c1.148-2,3.67-5.677,4.094-6.239a5.655,5.655,0,0,1,3.6-1.439,8.281,8.281,0,0,1,1.195-.025c.439,0,1.525,1.079,2.076,2.159.029.054.054.112.079.165a3.065,3.065,0,0,1,.277.986,6.089,6.089,0,0,1-.054,1.461h0c-.4,2.5-2.4,5.336-5.94,8.433A.115.115,0,0,1,559.731,157.151Zm-3.958-3.875.155.191.155.183.079.094.273.313.122.133h0l.133.14.227.237.158.162.227.223.223.212.216.2,1.04.874.36.263.4.288.169.115c3.472-3.047,5.429-5.828,5.818-8.275h0a5.89,5.89,0,0,0,.05-1.418,2.764,2.764,0,0,0-.259-.917,1.58,1.58,0,0,0-.076-.158,4.426,4.426,0,0,0-1.907-2.058,7.87,7.87,0,0,0-1.166.029,5.5,5.5,0,0,0-3.461,1.367c-.453.644-2.929,4.278-4.051,6.2.072.122.148.241.227.36.032.054.065.108.1.158l.13.191c.032.047.061.094.094.137l.112.155c.036.054.072.1.112.155l.112.148V153l.043.054h0l.043.054c.032.043.065.086.1.126l-.065.083Z",
    transform: "translate(-354.984 -91.299)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M526.1,171.316l-.194.176-.068.058c-.076.072-.158.144-.245.216l-.079.068-.022.022-.058.047c-.245.212-.511.435-.784.666l-.259.212h0l-.126.1h0l-.054.043-.151.126L524,173.1l-.155.122q-.317.266-.637.518l-.151.115h-.022a.886.886,0,0,1-.09.072l-.054.047-.112.09-.1.076-.086.068-.169.137-.151.119-.241.191h0l-.277.219-.72.572-.514.4s-.558.921-.72.946-1.313.173-1.313.173l-.989,1.266c-2.486,1.41-7.595,2.482-11.182,3.1-1.8.306-3.191.5-3.706.568a2.4,2.4,0,0,0-.317-1.9l.428-.176c2.126-.863,4.17-1.828,6.008-2.767,4.62-2.36,7.94-4.548,7.94-4.548l.8-.162s.155-.273.385-.662c.36-.6.881-1.472,1.281-2.018l.043-.054c.245-.335.633-.863,1.015-1.392l.651-.907.6-.846.1.162c.04.065.086.126.129.191s.061.094.094.137l.05.068a.526.526,0,0,0,.061.086l.112.158c.039.05.076.1.115.148h0l.032.04a.284.284,0,0,0,.025.036v.018l.043.054.1.13v.018a1.1,1.1,0,0,1,.086.108l.068.083.158.187.076.094.277.313.14.151.133.148h0l.151.158.072.076.158.158c.076.079.151.151.23.227l.112.108.112.1.219.2c.047.047.1.086.14.13l.083.072.083.072.072.065.079.065.1.079a.464.464,0,0,0,.061.058l.14.112.133.112.1.076.057.047.112.086.1.079.05.04a.594.594,0,0,1,.076.058A2.045,2.045,0,0,0,526.1,171.316Z",
    transform: "translate(-321.582 -105.723)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M492.156,205.946c-1.252.108-2.267.863-3,.975a7.62,7.62,0,0,1-1.5.054l-1.439-1.925s.165-.137.41-.327c.1-.083.219-.169.342-.263l.209-.155a6.819,6.819,0,0,1,.917-.59c.4-.025.993,0,1.644,0a5.108,5.108,0,0,0,1.964-.385,1.8,1.8,0,0,1,.259.32,2.4,2.4,0,0,1,.317,1.9A2.653,2.653,0,0,1,492.156,205.946Z",
    transform: "translate(-311.287 -129.321)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M217.032,191.052a32.558,32.558,0,0,1,.421,5.314h-.907l-3.681-.036h-.626a20.243,20.243,0,0,1-1.669-1.8c-.284-.446-.277-.36-.083-3.238a143.816,143.816,0,0,1-8-18.14,13.362,13.362,0,0,1,.475-2.8V168.5s1.9-4.058,4.987-9.221c1.9-3.177,3.889-6.969,5.1-9.329.694-1.353,1.13-2.238,1.144-2.267.576,1.673,1.079,3.81,1.374,5.037a1.561,1.561,0,0,0,1.169,1.173h0a12.417,12.417,0,0,0,1.234,4.49,42.138,42.138,0,0,1,1.687,3.958l-4.753,4.321v.7s-1.745,1.821-3.371,3.749a13.543,13.543,0,0,1,2.306,7.3c.043,1.112,1.669,11.513,1.72,11.822h0S215.838,190.357,217.032,191.052Z",
    transform: "translate(-129.638 -93.693)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M273.047,181.635l-2,2.245-.583.655-2.13-1.13,1.767-3.335Z",
    transform: "translate(-171.79 -114.43)",
    fill: "#427391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M275.742,181.635l-2,2.245-.583.655-.5-.266,1.767-2.364-1.885-1.356.252-.479Z",
    transform: "translate(-174.485 -114.43)",
    fill: "#253b60",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M481.377,291.911l-2,2.245-.586.655-2.13-1.13,1.767-3.332Z",
    transform: "translate(-305.167 -185.033)",
    fill: "#427391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M484.072,291.911l-2,2.245-.583.655-.5-.266,1.767-2.364-1.885-1.356.252-.475Z",
    transform: "translate(-307.862 -185.033)",
    fill: "#253b60",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M469.55,222.306s-2.8,4.677-3.1,4.875-8.1,8.455-8.225,8.667c-.047.079-.917,1.036-2,2.213-1.871,2.036-4.386,4.735-4.386,4.735s-.36.148-.849.338l-12.661-6.7c-1.1-1.36-2.1-2.612-2.58-3.1q-.461.615-.917,1.256L431.28,232.7c.64-1.015,1.263-1.975,1.878-2.878l.025-.032q1.223-1.821,2.389-3.368c.961-1.3,1.885-2.454,2.763-3.49a42.862,42.862,0,0,1,7.242-6.983c1.288-.928,2.652-.788,4.4-.309l19.568,6.67Z",
    transform: "translate(-276.114 -136.964)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M349.736,130l-6.3-1.648-16.7-6.228-20.2-11.3L302.9,108.8l-.889-.493-1.7-.953C288.75,100.9,277.672,94.73,277.237,94.55c-.917-.378-.64-4.429-.666-6.264s-.443-9.739-.486-10.131a36.87,36.87,0,0,1,.968-3.688c.475-1.623.971-3.278,1.126-3.8.32-1.079-2.457-4.289-2.457-4.289s-1.209-3.126-1-11.283c10.671,4.361,19.986,8.484,28.088,12.323l2.749,1.313,1.079.522c7.127,3.458,13.24,6.66,18.457,9.567h.022q1.439.8,2.792,1.576c17.91,10.247,24.051,16.42,24.051,16.42a4.634,4.634,0,0,1,1.015,1.328,19.113,19.113,0,0,1,.878,1.8c3.292,7.681,1.256,16.787-.961,22.947-.471,1.306-.946,2.479-1.382,3.479C350.517,128.628,349.736,130,349.736,130Z",
    transform: "translate(-175.868 -34.422)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M261.706,87.6l-3.724-2.159c4.63-10.265,5.037-17.014,2.486-21.393a13.583,13.583,0,0,1-2.378-1.079,4.9,4.9,0,0,1,4.465-8.7,2.648,2.648,0,0,1,1.266,1.137c3.709,6.62,3.7,13.718,2.547,19.565A43.133,43.133,0,0,1,261.706,87.6Z",
    transform: "translate(-163.683 -33.601)",
    fill: "#a5ccd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M360.126,210.6,285,170.822a56.589,56.589,0,0,0,3.191-8.682l3.645,2.033.514.284,1.047.59,48.509,27.343,17.629,9.944.529.3,2.486,1.4.64.36-1.184,2.234C361.241,207.818,360.914,209.289,360.126,210.6Z",
    transform: "translate(-182.462 -102.951)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M372.036,185.7l-3.652,6.631-.568-.32L296.36,151.678l5.116-6.6,2.069,1.191,62.537,36Z",
    transform: "translate(-189.735 -92.028)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M256.786,129.04l-16.636-8.8q.658-1.8,1.166-3.461a49.928,49.928,0,0,0,2.223-12.484c0-.27.025-.536.029-.8a36.806,36.806,0,0,0-.126-4.094,2.655,2.655,0,0,1,.3-1.489,2.705,2.705,0,0,1,2.54-1.439h0c.439,0,3.868,1.007,7.555,2.159l.745.234,2.277.72,2.619.828c2.011.633,3.562,1.133,3.958,1.263h.1l-1,8.275-.554-.241a46.577,46.577,0,0,1-.6,5.472c-.183.241-2.425,5.854-2.425,5.854Z",
    transform: "translate(-153.749 -60.907)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M287.64,139.7l-3.94-2.087c.586-1.529,1.079-3.015,1.525-4.447a56.486,56.486,0,0,0,2.4-12.592h0c.047-.676.076-1.331.094-1.961a41.7,41.7,0,0,0-.137-4.724,2.94,2.94,0,0,1,.327-1.655,3,3,0,0,1,3.411-1.5h.068a3.061,3.061,0,0,1,.554.23,4.677,4.677,0,0,1,2.486,4.271,35.034,35.034,0,0,1-.36,3.9c-.165,1.144-.4,2.432-.72,3.875-.23,1.033-.5,2.141-.835,3.328q-.259.932-.568,1.932c-.158.532-.331,1.079-.514,1.63l-.432,1.27c-.468,1.346-1,2.763-1.594,4.263a.153.153,0,0,0,0,.043Q288.607,137.5,287.64,139.7Z",
    transform: "translate(-181.63 -69.978)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M505.442,239.318a2.954,2.954,0,0,1-1.187,1.2,50.98,50.98,0,0,0-14.618,12.794q-1.41,1.745-2.824,3.76l-3.932-2.1c.144-.234.288-.468.435-.7l.18-.284q.946-1.493,1.86-2.849a.132.132,0,0,0,.025-.036c.468-.691.925-1.353,1.378-1.99h0l.5-.7c1.367-1.889,2.666-3.54,3.886-4.979a46.777,46.777,0,0,1,8.109-7.822,4.677,4.677,0,0,1,3.317-.853h0a4.7,4.7,0,0,1,1.612.507,2.99,2.99,0,0,1,1.259,4.044Z",
    transform: "translate(-309.149 -149.425)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M449.957,275.275l-2,2.245-.586.655-2.13-1.13,1.767-3.335Z",
    transform: "translate(-285.051 -174.38)",
    fill: "#253b60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M265.8,124.021h0l-16.19-7.2c0-.27.025-.536.029-.8l16.269,6.03C265.876,122.69,265.847,123.341,265.8,124.021Z",
    transform: "translate(-159.805 -73.43)",
    fill: "#427391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M289.156,140.517a.227.227,0,0,1-.3.1.223.223,0,0,1-.108-.281h0l.59-1.439.3-.72.147-.36.133-.36.525-1.475c.086-.245.18-.489.259-.72l.23-.748.461-1.49.4-1.507.2-.756.169-.759c.108-.507.227-1.011.327-1.522a52.28,52.28,0,0,0,.824-6.145l.054-.77.029-.77q0-.291.022-.583v-1.72c0-.255,0-.507-.025-.763s-.022-.5-.043-.752a2.783,2.783,0,0,0-.032-.36c-.014-.108-.025-.248-.04-.36a1.079,1.079,0,0,1,.471-1.051,1.05,1.05,0,0,1,.435-.169,1.079,1.079,0,0,1,1.115.579,1.032,1.032,0,0,1,.108.327v.079h0a2.848,2.848,0,0,0,.022.439,2.645,2.645,0,0,1,0,.414v.817c0,.27-.018.543-.029.81a6.715,6.715,0,0,1-.043.806l-.054.72c-.025.3-.05.6-.086.9l-.086.8-.108.8a53.788,53.788,0,0,1-1.277,6.253c-.137.514-.3,1.022-.439,1.533l-.223.763-.252.752-.511,1.5-.568,1.482-.284.72c-.1.248-.209.486-.313.72l-.63,1.439-.158.36-.176.36-.36.72Z",
    transform: "translate(-184.855 -72.79)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M507.519,242.237h-.054c-.2.09-.439.2-.662.317s-.446.234-.669.36-.446.248-.669.378-.443.252-.658.392l-.489.309c-.27.169-.54.36-.806.529l-.637.435-.637.478a45.935,45.935,0,0,0-4.731,4.012c-.36.36-.72.738-1.079,1.108l-.54.558-.522.583-1.043,1.162-.979,1.216-.489.608c-.165.2-.313.417-.468.626l-.921,1.263-.23.317-.212.327-1.284,1.975h0a.166.166,0,0,1-.223.047.169.169,0,0,1-.05-.216l.8-1.36.4-.68.2-.338.216-.331.867-1.32c.148-.219.284-.443.439-.658l.464-.637.932-1.277.989-1.234.5-.615.525-.6c.36-.392.694-.8,1.054-1.18a46.982,46.982,0,0,1,4.638-4.353l.615-.5.641-.482c.309-.241.63-.468.953-.694l.36-.241c.216-.155.442-.3.669-.446s.446-.291.676-.428.461-.284.7-.414.468-.263.72-.4a.782.782,0,1,1,.7,1.4Z",
    transform: "translate(-313.352 -153.279)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M372.8,191l-.5.7h0L304.08,153.2c.6-1.734,1.1-3.346,1.515-4.832.331-1.187.6-2.3.835-3.328l2.069,1.191a40.8,40.8,0,0,1-2,7.343C314.078,157.665,366.47,187.4,372.8,191Z",
    transform: "translate(-194.678 -92.003)",
    fill: "#253b60",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M362.807,211.435c-.147.23-.291.464-.435.7L294.65,176.288q.971-2.195,1.774-4.206v-.04c.6-1.493,1.122-2.907,1.59-4.253l.514.284,1.047.59h0a39.259,39.259,0,0,1-2.27,6.116C302.249,177.529,355.086,207.114,362.807,211.435Z",
    transform: "translate(-188.64 -106.568)",
    fill: "#253b60",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M280.054,59.543c3.033,5.332,1.59,14.391,1.59,14.391l-2.619-.824a27.251,27.251,0,0,0-2.979-16.863,2.648,2.648,0,0,0-1.266-1.137c60.177,24.584,77.231,41.735,77.231,41.735a4.634,4.634,0,0,1,1.015,1.328,18.67,18.67,0,0,1,.878,1.8C336.709,81.4,286.279,61.665,280.054,59.543Z",
    transform: "translate(-175.919 -34.428)",
    fill: "#a5ccd9",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M300.831,118.5a2.1,2.1,0,0,1-.666.259,2.159,2.159,0,0,1-1.259-.126,2.641,2.641,0,0,1-1.551-1.943,2.351,2.351,0,1,1,4.584-.935,2.569,2.569,0,0,1-1.108,2.745Z",
    transform: "translate(-190.335 -71.9)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M303.639,127.726a2.159,2.159,0,0,1-1.889.184v-.637a2.159,2.159,0,0,0,1.259.126,2.1,2.1,0,0,0,.666-.259Z",
    transform: "translate(-193.186 -80.543)",
    fill: "#427391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M533.211,242.7a2.357,2.357,0,0,1-2.447-.327,1.88,1.88,0,0,1-.529-.72,1.825,1.825,0,0,1-.137-.525,2.306,2.306,0,0,1,1.482-2.328,2.124,2.124,0,1,1,1.63,3.9Z",
    transform: "translate(-339.375 -151.904)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M530.137,246.858l-.425.266a1.933,1.933,0,0,1-.482-.684,1.973,1.973,0,0,1-.14-.565l.36-.241.036-.025a1.831,1.831,0,0,0,.137.525A1.878,1.878,0,0,0,530.137,246.858Z",
    transform: "translate(-338.733 -156.39)",
    fill: "#427391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M375.186,175.372l-62.537-36-2.069-1.191c.32-1.439.55-2.731.72-3.875l64.552,39.285C375.639,174.221,375.409,174.814,375.186,175.372Z",
    transform: "translate(-198.839 -85.133)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M270.67,77.912l-.745-.234c.04-.655.047-1.31.029-1.964a18.775,18.775,0,0,0-.525-3.958,14.368,14.368,0,0,0-1.439-3.67,11.512,11.512,0,0,0-1.079-1.608,9.253,9.253,0,0,0-.637-.72c-.108-.112-.227-.219-.338-.32q-.086-.079-.173-.151l-.083-.065-.043-.032h-.025a.8.8,0,0,1,.957-1.292l.076.058.058.054.112.1c.076.068.14.137.209.2.133.137.263.273.385.41.245.281.475.568.687.867a12.862,12.862,0,0,1,1.119,1.871,15.6,15.6,0,0,1,1.335,4.069,19.789,19.789,0,0,1,.288,4.181C270.814,76.452,270.756,77.186,270.67,77.912Z",
    transform: "translate(-169.841 -39.954)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M265.079,61.577a2.739,2.739,0,1,1-1.439-3.806A2.888,2.888,0,0,1,265.079,61.577Z",
    transform: "translate(-166.312 -36.024)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M229.185,45.539a4.453,4.453,0,0,1-.9,1.241l-.36-.058-.072.191-.065.18c-.173.471-.479,1.3-.72,1.972-.8.205-2.263.594-3.4.9l-1.587.425-.594-.691.41-.622a9.318,9.318,0,0,1-.479-2.983l-.36-.173a.36.36,0,0,1-.076-.586,10.764,10.764,0,0,0,1.392-1.522.181.181,0,0,1,0-.043,6.41,6.41,0,0,1-.094-1.162h0a6.609,6.609,0,0,0,4.479-.183,4.569,4.569,0,0,1,.36,2.234l.7.14h0a1.9,1.9,0,0,1,.576-.827C229.477,43.852,229.376,44.989,229.185,45.539Z",
    transform: "translate(-141.399 -26.304)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M229.832,41.2c-1.04.853-1.41,1.2-1.615,1.838v.05a4.2,4.2,0,0,1-.781-1.961l.065-.18.072-.191.36.058a4.453,4.453,0,0,0,.889-1.241,2.091,2.091,0,0,0,.108-.892h0a.72.72,0,0,0-.907-.673,1.953,1.953,0,0,0-.579.813l-.7-.14a4.569,4.569,0,0,0-.36-2.234,6.609,6.609,0,0,1-4.479.183h0a3.3,3.3,0,0,1-1.482-1.558,1.8,1.8,0,0,0,1.382.669,2.828,2.828,0,0,1-1.508-2.641,2.043,2.043,0,0,0,1.867,1.342c-.482-.27-.5-.561-.5-.59h0a2.372,2.372,0,0,0,1.774.335,26.935,26.935,0,0,1,3.677-.5l.259-.518a.6.6,0,0,0,.112.36,1.079,1.079,0,0,1,.622-.36.651.651,0,0,0-.032.9,5.641,5.641,0,0,1,2.087,3.565A7.915,7.915,0,0,1,229.832,41.2Z",
    transform: "translate(-141.034 -20.337)",
    fill: "#631e3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M228.56,51.887c.216-.144.432-.288.644-.435s.425-.3.626-.453a6.589,6.589,0,0,0,.6-.493,3.005,3.005,0,0,0,.511-.576,2.256,2.256,0,0,1-.457.633,5.349,5.349,0,0,1-.59.514c-.209.155-.425.3-.648.439a7.389,7.389,0,0,1-.684.371Z",
    transform: "translate(-146.328 -31.112)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M228.156,73.548c-.676,2.123-1.079,3.278-.324,5.789a33.231,33.231,0,0,0,2.227,5.3s.115-.025.317-.083c0,0,.277.59.766,1.522a49.82,49.82,0,0,0,2.907,4.864,15.7,15.7,0,0,1-5.12-2.3,24.264,24.264,0,0,1-2.256-9.854,7.037,7.037,0,0,1-2.544.1,29.945,29.945,0,0,1,1.838-4.677c.72-1.5,1.324-2.659,1.324-2.659l-.133-.594h.025l.1-.068.04-.018c.061-.04.14-.09.237-.144h.036l.094-.054c.1-.058.223-.119.36-.183l.061-.029h.079l.234-.1.061-.022a8.13,8.13,0,0,1,.849-.306l.234-.068.09-.025.151-.04.255-.065h.086l.18-.036.086-.018h.1l.173-.032h.291l.187-.022h0l.148-.018h.162l.32-.029a19.285,19.285,0,0,0,1.389,1.8h0a1.993,1.993,0,0,1,1.115.917,8.725,8.725,0,0,1,1.029,2.849.126.126,0,0,0,0,.022h0a7.322,7.322,0,0,0-1.547-2.116l-.115-.281a7.335,7.335,0,0,0-2.259-1.176,6.584,6.584,0,0,0-3.206,1.7C228.188,73.44,228.174,73.494,228.156,73.548Z",
    transform: "translate(-143.492 -43.756)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M243.248,86.464a5.1,5.1,0,0,1-.669.36,9.429,9.429,0,0,1-1.439.482l-.076.018-.09.025-.112.025h-.155l-.1.025h-.061l-.151.032h-.083l-.169.032H239.7s-.205-.576-.385-1.22a16.449,16.449,0,0,1-3.047,1.277c-.2.058-.317.083-.317.083a33.236,33.236,0,0,1-2.227-5.3,7.654,7.654,0,0,1,.205-5.418h0l.119-.36c.018-.054.032-.108.05-.162.1-.112.2-.212.306-.309l.137-.126.137-.119h0a6.547,6.547,0,0,1,.817-.576,6.376,6.376,0,0,1,1.8-.745,7.336,7.336,0,0,1,2.267,1.263l.115.281a7.321,7.321,0,0,1,1.547,2.116,3.882,3.882,0,0,1,.18.482A62.266,62.266,0,0,0,243.248,86.464Z",
    transform: "translate(-149.374 -46.835)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M243.248,86.464a5.1,5.1,0,0,1-.669.36,9.429,9.429,0,0,1-1.439.482l-.076.018-.09.025-.112.025h-.155l-.1.025h-.061l-.151.032h-.083l-.169.032H239.7s-.205-.576-.385-1.22a16.449,16.449,0,0,1-3.047,1.277c-.2.058-.317.083-.317.083a33.236,33.236,0,0,1-2.227-5.3,7.654,7.654,0,0,1,.205-5.418h0l.119-.36c.018-.054.032-.108.05-.162.1-.112.2-.212.306-.309l.137-.126.137-.119h0a6.547,6.547,0,0,1,.817-.576,6.376,6.376,0,0,1,1.8-.745,7.336,7.336,0,0,1,2.267,1.263l.115.281a7.321,7.321,0,0,1,1.547,2.116,3.882,3.882,0,0,1,.18.482A62.266,62.266,0,0,0,243.248,86.464Z",
    transform: "translate(-149.374 -46.835)",
    fill: "#f7ddce",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M251.71,81c.263.651.507,1.306.741,1.968s.443,1.331.669,1.99.407,1.342.583,2.022.335,1.36.461,2.051c-.162-.684-.36-1.356-.533-2.033s-.378-1.32-.608-2-.425-1.331-.644-2S251.937,81.666,251.71,81Z",
    transform: "translate(-161.15 -51.003)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M245.455,167.942q-.158.907-.4,1.867c-.043.176-.09.36-.14.532-.529.18-1.007.338-1.439.475a7.782,7.782,0,0,1-3.389.576,2.213,2.213,0,0,1-.935-.518,4.758,4.758,0,0,1-.694-.72l.554-1.662s-.72-12.376-1.9-15.985l.148-1.731a86.331,86.331,0,0,0-1.191-9.11,7.516,7.516,0,0,0-.5-1.576l-.054-2.349s-1.587-4.71-3.087-8.635l-.029-.072-.173-.45c-.637-1.644-1.241-3.1-1.687-3.958a11.83,11.83,0,0,1-1.184-3.986.72.72,0,0,0-.558-.622.72.72,0,0,1-.547-.558,56.634,56.634,0,0,0-1.5-5.526h0a9.281,9.281,0,0,0-.86-1.946,10.146,10.146,0,0,1-.921-1.749,2.285,2.285,0,0,1-.6-1.241l-.306-2.187s-2.95-6.544-1.6-11.513a.335.335,0,0,1,.36-.245h0c.191.025.471.05.788.061a6.1,6.1,0,0,0,1.608-.126l.148-.04a24.264,24.264,0,0,0,2.256,9.854h0a18.763,18.763,0,0,0,2.468,1.374c.327.148.633.277.917.385l.126.047c.155.058.3.112.443.155l.248.083.4.119.09.025c.068.018.13.036.191.047l.09.025.137.032a6.191,6.191,0,0,0,.741.126l.108.255,3.375,7.876,1.63,2.36.878,1.27.756,3.069.094.392.885,3.6.774,2.357.237.72s.094.741.216,1.781c.068.558.14,1.2.212,1.86.169,1.6.324,3.3.317,4.109a5.762,5.762,0,0,1,1.421,2.457c.317,1.115.72,12.2.389,18.77A17.444,17.444,0,0,1,245.455,167.942Z",
    transform: "translate(-142.198 -59.934)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M222.186,287.545h-13s-.464-.759-.13-.817c5.861-.425,7.937-3.828,7.937-3.828l3.681.04a8.333,8.333,0,0,0,1.051,1.695C222.557,285.634,222.186,287.545,222.186,287.545Z",
    transform: "translate(-133.763 -180.263)",
    fill: "#2c0600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M222.375,296.116H209.4a.151.151,0,0,1-.151-.155h0a.151.151,0,0,1,.151-.151h12.974a.151.151,0,0,1,.151.151h0a.151.151,0,0,1-.151.155Z",
    transform: "translate(-133.966 -188.529)",
    fill: "#2c0600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M261.476,309.979h-13s-.464-.759-.13-.817c4.389-.317,6.656-2.306,7.519-3.285a2.159,2.159,0,0,0,.935.514,7.762,7.762,0,0,0,3.389-.572,7.444,7.444,0,0,0,.824,1.248C261.847,308.069,261.476,309.979,261.476,309.979Z",
    transform: "translate(-158.917 -194.937)",
    fill: "#2c0600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M261.683,317.686H248.731a.151.151,0,0,1-.151-.155h0a.151.151,0,0,1,.151-.151h12.952a.151.151,0,0,1,.151.151h0a.151.151,0,0,1-.151.155Z",
    transform: "translate(-159.145 -202.338)",
    fill: "#2c0600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M255.6,211.52a86.339,86.339,0,0,0-1.191-9.11,7.518,7.518,0,0,0-.5-1.576l-.054-2.349s-1.587-4.71-3.087-8.635l3.414,8.563s.04.471.1,2.306c1.238,3.026,1.277,7.347,1.378,8.53.155-.4.425-1.489.425-1.489A13.7,13.7,0,0,1,255.6,211.52Z",
    transform: "translate(-160.548 -120.691)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M272.153,255.883c-.137.766-.313,1.569-.54,2.4-.529.18-1.007.338-1.439.475a7.782,7.782,0,0,1-3.389.576,2.213,2.213,0,0,1-.935-.518,4.76,4.76,0,0,1-.694-.72l.554-1.662s-.72-12.376-1.9-15.985a28.611,28.611,0,0,1,4.656-8.138c-.086.173-2.853,5.728-3.062,8.671.792,4.227,2.72,14.917,2.72,14.917S269.718,257.541,272.153,255.883Z",
    transform: "translate(-168.896 -147.875)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M237.466,77.52h0a7.321,7.321,0,0,0-1.547-2.116l-.115-.281a7.336,7.336,0,0,0-2.259-1.176,6.659,6.659,0,0,0-2.616,1.32,5.828,5.828,0,0,0-.6.579c-.018.054-.032.108-.05.162a12.714,12.714,0,0,0-1.914,4.292h-.917s1.543-5.425,3.688-6.325a6.045,6.045,0,0,1,2.206-.461,6.361,6.361,0,0,1,1.961.255h0a.742.742,0,0,1,.119.036.993.993,0,0,1,.169.072l.108.061.129.086c.036.032.072.058.108.094a1.967,1.967,0,0,1,.227.23,1.119,1.119,0,0,1,.083.1c.061.076.115.155.173.237A8.724,8.724,0,0,1,237.466,77.52Z",
    transform: "translate(-145.618 -46.21)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M254.056,129.431a1.638,1.638,0,0,0-.187.065,5.7,5.7,0,0,0-1.205.594l-.04.025a4.321,4.321,0,0,0-.5.392l-.133.13-.054.054a1.152,1.152,0,0,0-.094.1c-5.879-9.923-5.537-11.682-5.425-13.967-.2-.252-.392-.511-.583-.77s-.439-.615-.648-.921a49.822,49.822,0,0,1-2.907-4.864c-.489-.932-.766-1.522-.766-1.522a16.449,16.449,0,0,0,3.047-1.277c.18.644.385,1.22.385,1.22h.432l.169-.032h.083l.155-.032h.032l.133-.032h.155l.112-.025.09-.025.076-.018a9.43,9.43,0,0,0,1.439-.482c.094.291.191.6.284.91s.162.54.241.813c.756,2.623,1.414,5.494,1.414,5.494l.72.579C251.264,120.3,253.678,128.2,254.056,129.431Z",
    transform: "translate(-154.619 -67.95)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M234.362,60.419H234.2l-.148.018h0l-.187.025h-.288l-.176.029-.1.022h-.086l-.18.04-.086.022-.255.061-.151.04-.09.025-.234.068c-.317.1-.6.2-.849.3l-.061.029-.234.1h-.079l-.061.029c-.137.065-.255.126-.36.183l-.094.054h-.036l-.245.291-.036.022-.389-1.216a2.159,2.159,0,0,1-.914-.6,4.126,4.126,0,0,0-.054-1.266c-.076-.317-.183-.385-.183-.385l3.4-.9c.252-.669.558-1.5.72-1.968a4.2,4.2,0,0,0,.781,1.961A20.583,20.583,0,0,0,234.362,60.419Z",
    transform: "translate(-146.367 -34.639)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M234.343,60.4a2.905,2.905,0,0,0-.309.032,15.21,15.21,0,0,0-1.662-2.339,19.623,19.623,0,0,0-3.6.568c-.076-.317-.183-.385-.183-.385l3.4-.9c.252-.669.558-1.5.72-1.968a4.2,4.2,0,0,0,.781,1.961,20.577,20.577,0,0,0,.853,3.029Z",
    transform: "translate(-146.348 -34.62)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M232.6,70.641l-.094.054h-.036l-.23.18-.036.022-.389-1.216s.489.176.6.2l-.212.137Z",
    transform: "translate(-148.416 -43.756)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M274.6,174.35l-1.759,1.036-.263-.025-.774-.076a9.692,9.692,0,0,1-.939-3.278,16.006,16.006,0,0,0-.986-2.159,1.307,1.307,0,0,1,.115-.14,1.153,1.153,0,0,1,.094-.1l.054-.054c.04-.043.083-.083.133-.13a4.318,4.318,0,0,1,.511-.392l.04-.025a5.666,5.666,0,0,1,1.392-.658l.255-.079a18.544,18.544,0,0,1,.439,3.044l.108.086a4.317,4.317,0,0,1,1.561,2.821A.717.717,0,0,1,274.6,174.35Z",
    transform: "translate(-172.782 -106.875)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M277.995,183.452c.047.155-.288.4-.752.547s-.881.137-.932-.018.288-.4.752-.547S277.948,183.3,277.995,183.452Z",
    transform: "translate(-176.896 -116.516)",
    fill: "#f8957e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M278.273,185.724l-.781.788-.547-.061v.2l-.7.248-.166.058-.842-.849.77.076.263.025,1.759-1.036Z",
    transform: "translate(-176.214 -117.695)",
    fill: "#fee0d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M283,184.555l.788-.345.252.263-.8.637Z",
    transform: "translate(-181.182 -117.08)",
    fill: "#fee0d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M224.7,57.893a.051.051,0,0,1-.007-.1,1.6,1.6,0,0,0,.831-.389.047.047,0,0,1,.068,0,.054.054,0,0,1,0,.072,1.677,1.677,0,0,1-.9.428Z",
    transform: "translate(-143.824 -35.887)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M256.9,152.8l-.921-.259-.756-3.515-5.354-7.994a26.724,26.724,0,0,1-3.558-7.75l-1.961-7.059c.36.169.72.313,1.043.432l.263.094.428.144.4.119.09.025c.068.018.13.036.191.047l.09.025.137.032c.209.306.425.615.648.921s.385.518.583.77c-.112,2.285-.453,4.044,5.426,13.967a1.308,1.308,0,0,0-.115.14,16.005,16.005,0,0,1,.986,2.159,9.693,9.693,0,0,0,.939,3.278l.845.849.151-.054s.094.741.216,1.781C256.755,151.495,256.816,152.139,256.9,152.8Z",
    transform: "translate(-156.437 -79.954)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M239.34,97.547l-.137-.032-.09-.025a.817.817,0,0,1-.191-.047l-.09-.025-.4-.119L238,97.154,236.354,94.3l-1.119-.259s-1.928-5.372-2.655-8.142.917-5.9.917-5.9-.032.108-.05.162c-.676,2.123-1.079,3.278-.324,5.789a33.234,33.234,0,0,0,2.227,5.3s.115-.025.317-.083c0,0,.277.59.766,1.522a49.829,49.829,0,0,0,2.907,4.857Z",
    transform: "translate(-148.783 -50.363)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M248.337,109.647a8.5,8.5,0,0,1-3.515.14,2.627,2.627,0,0,0-2.565.482c-.489-.932-.766-1.522-.766-1.522a16.449,16.449,0,0,0,3.047-1.277c.18.644.385,1.216.385,1.216a11.837,11.837,0,0,0,2.878-.763C247.988,108.459,248.15,109.049,248.337,109.647Z",
    transform: "translate(-154.606 -67.95)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M240.876,124.159a1.465,1.465,0,0,1-.191.532,19.7,19.7,0,0,1-3.195-2.292,18.766,18.766,0,0,0,2.468,1.374C240.286,123.922,240.591,124.055,240.876,124.159Z",
    transform: "translate(-152.046 -77.508)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M240.912,49.754a.05.05,0,0,1-.025-.094,1.669,1.669,0,0,0,.961-1.633.393.393,0,0,0-.079-.144.385.385,0,0,0-.288-.122h0a.471.471,0,0,0-.36.151,1.183,1.183,0,0,0-.155.209.051.051,0,0,1-.09-.047,1.037,1.037,0,0,1,.173-.23.579.579,0,0,1,.417-.183h0a.475.475,0,0,1,.464.338h0a1.767,1.767,0,0,1-1.015,1.734Z",
    transform: "translate(-154.204 -29.658)",
    fill: "#631e3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M229.329,44.918a3.1,3.1,0,0,0-.162-2.159,11.968,11.968,0,0,1-4.274,1.079V43.8a6.413,6.413,0,0,1-.094-1.162h0a6.609,6.609,0,0,0,4.479-.183,4.569,4.569,0,0,1,.36,2.234l.7.14Z",
    transform: "translate(-143.921 -26.323)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M226.119,46.89l1.1.4h-1.245a.381.381,0,0,1,.14-.4Z",
    transform: "translate(-144.668 -29.165)",
    fill: "#4a162c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M226.07,44.926l2.058.838-1.792-.964-.018-.27Z",
    transform: "translate(-144.734 -27.655)",
    fill: "#631e3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M264.171,131.883a1.635,1.635,0,0,0-.187.065l-3.929-13.01-.543-.36-2.2-6.451.439-.612.475-.216c.083.266.162.54.241.813.756,2.623,1.414,5.494,1.414,5.494l.72.579C261.379,122.748,263.793,130.656,264.171,131.883Z",
    transform: "translate(-164.735 -70.402)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M232.648,37.764a5.213,5.213,0,0,1-3.022-3.684s-.684.2-2.184.536c-2.281.479-3.206-.514-3.292-.619a2.372,2.372,0,0,0,1.774.335,26.936,26.936,0,0,1,3.677-.5l.259-.518a.6.6,0,0,0,.112.36,1.079,1.079,0,0,1,.622-.36.651.651,0,0,0-.032.9A5.641,5.641,0,0,1,232.648,37.764Z",
    transform: "translate(-143.505 -20.471)",
    fill: "#7b355a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M241.452,50.614a3.985,3.985,0,0,0-.522,2.353v.05a4.2,4.2,0,0,1-.781-1.961l.065-.18.072-.191.36.058a4.454,4.454,0,0,0,.889-1.241,2.09,2.09,0,0,0,.108-.892A3.63,3.63,0,0,1,241.452,50.614Z",
    transform: "translate(-153.749 -30.267)",
    fill: "#4a162c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M245.191,71.023a6.361,6.361,0,0,0-1.961-.255l-.36-1.439h.1l.187-.022h0l.147-.018h.162l.32-.029a19.307,19.307,0,0,0,1.407,1.763Z",
    transform: "translate(-155.49 -43.487)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M248.186,98.357H248.1l-.169.032h-.443s-.205-.576-.385-1.22L245.48,91.51Z",
    transform: "translate(-157.161 -57.732)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M227.928,93.3a6.1,6.1,0,0,1-1.608.126l.248-1.137h1.245v.043Z",
    transform: "translate(-144.894 -58.231)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M228.123,93.476s-.878.079-1.234.09h-.079l.234-.946h.054l.907.018Z",
    transform: "translate(-145.208 -58.443)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M227.079,92.57h0l-.219.946h-.079l.234-.946Z",
    transform: "translate(-145.189 -58.411)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M231.914,80.43l-.119.36h0a18.708,18.708,0,0,0-1.623,3.976v-.043H230a12.715,12.715,0,0,1,1.914-4.292Z",
    transform: "translate(-147.25 -50.638)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M237.428,106.825c-.14-.043-.288-.1-.443-.155l-.126-.047c-.284-.108-.59-.237-.917-.385a18.766,18.766,0,0,1-2.468-1.374h0a24.263,24.263,0,0,1-2.256-9.854l.209.076s-.313,3.645,2.191,9.646c1.957.774,3.565,1.515,3.565,1.515Z",
    transform: "translate(-148.029 -59.973)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M282.166,242.547q-.158.907-.4,1.867l-.8-8.7-1.518-.874,1.051-7.527-.813-15.83a5.761,5.761,0,0,1,1.421,2.457c.317,1.115.72,12.2.389,18.77A17.638,17.638,0,0,1,282.166,242.547Z",
    transform: "translate(-178.909 -134.539)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M248.666,172.016a.543.543,0,0,1-.5-.338l-1.936-4.861,4.173-.6,1.141,4.9a.54.54,0,0,1-.09.432.529.529,0,0,1-.381.223l-2.331.241Zm-2.3-5.12,1.889,4.746a.439.439,0,0,0,.453.273l2.331-.241a.453.453,0,0,0,.313-.18.435.435,0,0,0,.068-.36l-1.1-4.81Z",
    transform: "translate(-157.641 -105.563)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_652",
    "data-name": "Rectangle 652",
    width: 5.343,
    height: 0.101,
    transform: "matrix(0.995, -0.095, 0.095, 0.995, 88.653, 62.219)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M566.4,118.621l-.241-.148-.191.36c-.04.065-.086.144-.14.241l-.759,1.346c-1.079.36-2.18.63-2.993.817s-1.288.27-1.288.27l-.5-.112a21.2,21.2,0,0,1-.324-3.418,11.92,11.92,0,0,0,.579-2.04.259.259,0,0,1,.025-.137c.025-.043,0-.029,0-.04s.018-.1.025-.155a.694.694,0,0,0,0-.122c.047-.306.057-.478.057-.478l.108-.443a1.026,1.026,0,0,1,.05-.2,2.234,2.234,0,0,1,.72-.36.722.722,0,0,1,.147-.022,12.676,12.676,0,0,1,3.882,1.579,5.627,5.627,0,0,0-.054,1.051v.209l.532.148a1.439,1.439,0,0,1,.881-1.212.547.547,0,0,1,.626.212c.04.068.076.133.1.194C568.249,117.4,566.4,118.621,566.4,118.621Z",
    transform: "translate(-358.497 -72.118)",
    fill: "#f8957e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M577.664,121.695a.05.05,0,0,1-.029-.09c1.277-.838,1.23-1.439,1.151-1.687a.421.421,0,0,0-.36-.317.565.565,0,0,0-.518.471.05.05,0,0,1-.058.043.054.054,0,0,1-.043-.058.673.673,0,0,1,.608-.558.525.525,0,0,1,.475.385c.086.252.144.928-1.194,1.8A.036.036,0,0,1,577.664,121.695Z",
    transform: "translate(-369.801 -75.652)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M566.571,116.559l-5-.662a.258.258,0,0,1,.025-.137c.025-.043,0-.029,0-.04s.018-.1.025-.155a.688.688,0,0,0,0-.122c.047-.306.057-.479.057-.479l.108-.443a1.031,1.031,0,0,1,.05-.2,2.233,2.233,0,0,1,.719-.36.72.72,0,0,1,.148-.022,12.675,12.675,0,0,1,3.882,1.579,5.62,5.62,0,0,0-.014,1.04Z",
    transform: "translate(-359.528 -72.092)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M562.645,109.614l-.72,1.022-.083.119c-.432-.284-.86-.547-1.284-.8-.029-.061-.065-.126-.1-.194a.547.547,0,0,0-.626-.212c-.389-.209-.77-.4-1.137-.572l-.137-.065c-.5-.234-.975-.439-1.418-.619l-.194-.076-.4-.151-.187-.068-.428-.151-.1-.032-.086-.029-.083-.029H555.6c-.633-.209-1.079-.327-1.3-.381h-.133s-.273,0-.719-.043c-.6-.043-1.5-.119-2.447-.237a2.648,2.648,0,0,1-2.159-1.371s.885.05,2,.14,2.472.227,3.4.392c0-.025.025-.054.036-.076a3.274,3.274,0,0,1,1.252-1.439,2.608,2.608,0,0,1,1.259-.407c.72,0,3.209.04,4.742,1.5A3.6,3.6,0,0,1,562.645,109.614Z",
    transform: "translate(-351.378 -65.946)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M577.593,124.107l-.165-.112c-.77-.518-1.079-.756-1.187-1.126l.14-.245.191-.36.241.148s1.86-1.227,1.3-2.482c.425.241.853.507,1.284.8l.083-.122S579.791,122.114,577.593,124.107Z",
    transform: "translate(-368.92 -75.927)",
    fill: "#602227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M568.06,114.787a1.439,1.439,0,0,0-.882,1.212l-.532-.148a5.692,5.692,0,0,1,.043-1.259,12.947,12.947,0,0,0-3.882-1.579.72.72,0,0,0-.147.022,2.234,2.234,0,0,0-.72.36s-.36-.13-.248-.885l.72.047h.133c.212.054.669.173,1.3.381h.061l.083.029.086.029.1.032.428.151.187.068.4.151.2.079c.443.176.917.381,1.418.615l.137.065C567.29,114.388,567.671,114.579,568.06,114.787Z",
    transform: "translate(-359.592 -71.177)",
    fill: "#602227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M553.769,110.563a.791.791,0,0,1-.05.2,17.872,17.872,0,0,1-3.4-.327c-1.007-.5-1.374-2.31-1.385-2.367a2.641,2.641,0,0,0,2.159,1.371c.943.119,1.849.194,2.447.237C553.42,110.434,553.769,110.563,553.769,110.563Z",
    transform: "translate(-351.435 -68.334)",
    fill: "#253b60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M561.649,118.12a3.848,3.848,0,0,1-.1.6,4.162,4.162,0,0,1-.183.59,3.958,3.958,0,0,1-.594,1.079v-.032a.864.864,0,0,0,.446.45.809.809,0,0,1-.507-.421.036.036,0,0,1,0-.032h0a5.705,5.705,0,0,0,.561-1.072A8.224,8.224,0,0,0,561.649,118.12Z",
    transform: "translate(-358.977 -74.768)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M565.244,118.2a1.17,1.17,0,0,0,0,.489l1.058.13Z",
    transform: "translate(-361.863 -74.819)",
    fill: "#30110c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M565.055,115.36a1.331,1.331,0,0,0-.072.615l1.677.763-1.482-1.011Z",
    transform: "translate(-361.707 -73.001)",
    fill: "#602227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M562.064,118.12l-.054.36-.36-.047h0v-.04c0-.011.018-.1.025-.155Z",
    transform: "translate(-359.579 -74.768)",
    fill: "#30110c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M561.91,116.036l.453-.151.068-.435-.2.266-.284.108-.025.108Z",
    transform: "translate(-359.745 -73.059)",
    fill: "#602227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M562.969,130.745a3.6,3.6,0,0,1-.529-.047.05.05,0,0,1,0-.1c.36.061.925.09,1-.1a.05.05,0,0,1,.094.036C563.466,130.7,563.207,130.745,562.969,130.745Z",
    transform: "translate(-360.053 -82.677)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M568.29,123.2a3.887,3.887,0,0,0,1-.619,2.982,2.982,0,0,0,.4-.421,3.862,3.862,0,0,0,.327-.489,2.016,2.016,0,0,1-.266.536,2.069,2.069,0,0,1-.4.45A2.431,2.431,0,0,1,568.29,123.2Z",
    transform: "translate(-363.83 -77.041)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M538.71,250.339c-.047.144-.086.288-.122.41h0a.191.191,0,0,1-.108-.169v-.36C538.573,250.274,538.667,250.306,538.71,250.339Z",
    transform: "translate(-344.745 -159.341)",
    fill: "#fee0d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M576.383,153.812a26.03,26.03,0,0,1-.759,5.8h-2.385l-.191-.022-.3-.036H572.6l-.155-.022-.317-.05-.223-.036h-.1l-.216-.043h0l-.194-.036-.2-.043-.407-.094-.119-.029-.234-.061-.1-.029-.133-.036h-.025l-.155-.047h-.18l-.18-.054-.183-.061-.1-.036-.083-.029-.155-.054-.219-.079-.176-.068c-.151-.058-.3-.119-.453-.187-.234-2.223-.36-6.688-.338-7.44a5.506,5.506,0,0,1,2.033-3.213,8.607,8.607,0,0,1,.943-.72.361.361,0,0,1,.083-.036,1.292,1.292,0,0,1,.4-.047,5.944,5.944,0,0,1,2.371.626l.162.086a3.037,3.037,0,0,1,.774.615,5.848,5.848,0,0,1,.8,1.2A8.444,8.444,0,0,1,576.383,153.812Z",
    transform: "translate(-363.608 -93.263)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M563.375,180.025a1.415,1.415,0,0,1-.054.255l-.022.086c-.022.1-.047.212-.072.32a.55.55,0,0,1-.025.1.067.067,0,0,1,0,.025v.072c-.076.317-.158.651-.248,1-.029.108-.054.216-.083.324h0a.683.683,0,0,1-.04.158h0v.065a2,2,0,0,1-.05.194c-.018.065,0,.043,0,.065a1.73,1.73,0,0,1-.05.191l-.216.792-.054.2a.067.067,0,0,1,0,.025l-.029.108a.094.094,0,0,1-.018.068.684.684,0,0,0-.04.14l-.032.119a.4.4,0,0,1-.029.108c-.011.036-.039.14-.058.209l-.137.482v.022c-.032.115-.065.227-.094.335-.1.36-.187.651-.255.9l-.184.63a4.179,4.179,0,0,1-.029,1.187l-.964.91-.061,1.6c-1.187,2.6-4.7,6.476-7.242,9.066-1.266,1.3-2.292,2.277-2.67,2.634a2.407,2.407,0,0,0-1.371-1.356c1.313-2.072,2.486-4.2,3.49-6.159,2.36-4.616,3.767-8.336,3.767-8.336l.554-.6s-.032-.309-.076-.759c-.068-.72-.155-1.8-.144-2.454s0-1.932,0-2.839v-1.04l.176.068.219.079.158.058.079.025.1.036.184.058.18.058h.108l.068.022.155.043h.025l.133.036.1.029.234.061.119.029.407.094.2.043.191.036h0l.216.04h.1l.219.036.32.05.155.022h.151l.3.036.191.022h2.1Z",
    transform: "translate(-351.64 -113.661)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M576.9,180.025a1.416,1.416,0,0,1-.054.255l-.022.086c-.022.1-.047.212-.072.32a.55.55,0,0,1-.025.1.067.067,0,0,1,0,.025v.072c-.076.317-.158.651-.248,1-.029.108-.054.216-.083.324h0a.683.683,0,0,1-.04.158h0v.065a1.979,1.979,0,0,1-.05.194c-.018.065,0,.043,0,.065a1.733,1.733,0,0,1-.05.191l-.216.792-.054.2a.065.065,0,0,1,0,.025l-.029.108a.094.094,0,0,1-.018.068.684.684,0,0,0-.04.14l-.032.119a.4.4,0,0,1-.029.108c-.011.036-.04.14-.058.209l-.137.482v.022c-.032.115-.065.227-.094.335-.1.36-.187.651-.255.9,0,0,0-1.328-.093-2.738a2.519,2.519,0,0,0-1.706-2.18l-.266-.094a12.15,12.15,0,0,1-2.857-1.464v-1.04l.176.068.22.079.158.058.079.025.1.036.184.058.18.058h0l.086.029h.021l.068.022.155.043h.025l.133.036.1.029.234.061.119.029.407.094.2.043.191.036h0l.216.04h.1l.219.036.32.05.155.022h.151l.3.036.191.022h2.1Z",
    transform: "translate(-365.162 -113.661)",
    fill: "#d1625b",
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M543.729,242.13c-.95.82-1.331,2.029-1.86,2.551a7.92,7.92,0,0,1-1.184.921l-2.3-.72s.054-.209.14-.507c.036-.122.076-.266.122-.41.025-.083.054-.166.079-.248a6.558,6.558,0,0,1,.4-1.015c.306-.255.813-.572,1.328-.971a5.2,5.2,0,0,0,1.367-1.461,1.623,1.623,0,0,1,.4.1,2.407,2.407,0,0,1,1.371,1.356A3.013,3.013,0,0,1,543.729,242.13Z",
    transform: "translate(-344.687 -152.971)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M537.891,253.1l-.281,1.13.561.176.353-.309.651.191.32-.2.432.014.259-.284Z",
    transform: "translate(-344.188 -161.185)",
    fill: "#fee0d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M540.516,244.34c-.514.4-1.022.72-1.328.971a6.55,6.55,0,0,0-.4,1.015c-.025.083-.054.165-.079.248-.061-.032-.137-.065-.23-.108a1.736,1.736,0,0,1,.568-1.414Z",
    transform: "translate(-344.745 -155.577)",
    fill: "#fee0d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M543.76,249.465h0a.479.479,0,0,1-.669.112l-.72-.529a.482.482,0,0,1-.112-.673h0a.482.482,0,0,1,.673-.108l.719.529a.479.479,0,0,1,.108.669Z",
    transform: "translate(-347.107 -158.033)",
    fill: "#f8957e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M543.733,250.134a.478.478,0,0,1-.669.112l-.737-.532a.479.479,0,0,1-.187-.493.517.517,0,0,0,.187.277l.737.529a.478.478,0,0,0,.669-.108.485.485,0,0,0,.079-.176A.471.471,0,0,1,543.733,250.134Z",
    transform: "translate(-347.08 -158.701)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M558.313,176.113l-.558.6s-1.407,3.72-3.767,8.34c-.173-1.943-.4-4.677-.4-4.677l-.835-1.619c-.029-.612.144-2.738.144-2.738l-.464-2.493c-.112-.608-.255-1.364-.432-2.306v-.094a13.629,13.629,0,0,1-.673-4.461,5.289,5.289,0,0,1,.788-2.411h0a6.284,6.284,0,0,0,.36-.784l.27.058q.5.1.917.162c.194.029.36.05.536.065a7.885,7.885,0,0,0,1.141.036h.061s-.5,6.922,1.029,10.167c.755.63,1.349,1.079,1.8,1.407C558.277,175.8,558.313,176.113,558.313,176.113Z",
    transform: "translate(-352.964 -103.802)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M574.12,254.992s-.752.223-1.666.461a11.8,11.8,0,0,1-3.087.54,2.158,2.158,0,0,1-.968-.54l-.115-.1h0c-.158-.155-.295-.306-.388-.417l-.148-.187.572-1.723a126.152,126.152,0,0,0-2.026-16.6l.212-1.72c0-2-1.22-9.8-1.22-9.8l-.464-.925c-.1-.687-.122-2.6-.122-2.6s-2.3-6.159-3.144-8.89a43.453,43.453,0,0,1-1.155-5.857c-.021-.13-.036-.259-.057-.385s.068-.223.1-.324c2.518-2.6,5.951-6.379,7.12-8.941l.061-1.6s.845-.792.964-.91a4.069,4.069,0,0,0,.025-1.191s.072-.234.187-.63c.068-.241.158-.547.255-.892.029-.108.061-.219.094-.335v-.022c.043-.158.09-.317.133-.482.022-.068.043-.14.061-.209s0-.072.029-.108l.032-.119a.511.511,0,0,1,.04-.14c.014-.047,0-.043.018-.068l.032-.108v-.022l.054-.2.216-.792.05-.191a.441.441,0,0,0,0-.065.736.736,0,0,1,.05-.194c.018-.065,0-.043,0-.065.036,1.4.194,2.983.36,4.242.162,1.324.317,2.281.317,2.281l.273.461A9.371,9.371,0,0,1,572.1,199.8c.277,4.476.23,11.38.133,11.873a11.861,11.861,0,0,1-.428,1.457l.72,7.264,1.317,2.457c.813,4.317.4,18.874.4,18.874a15.058,15.058,0,0,1,.813,4.148C575.358,248.919,574.12,254.992,574.12,254.992Z",
    transform: "translate(-358.741 -119.91)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M559.517,161.208v1.018h0a7.1,7.1,0,0,1-1.137-.032q-.248-.022-.54-.065l.335-1.079.187.025.306.036.752.1Z",
    transform: "translate(-357.14 -102.253)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M564.291,151.992c0,.752.1,5.217.342,7.444.147.065.3.126.45.184V163.5c0,.662.076,1.738.144,2.454-.461-.324-1.054-.777-1.8-1.407-1.526-3.238-1.029-10.167-1.029-10.167h-.054v-1.018h-.1s1.216-3.468,4.094-4.569A5.6,5.6,0,0,0,564.291,151.992Z",
    transform: "translate(-359.957 -94.404)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M569.182,146.435h-.09c-.126-.022-.381-.068-.72-.119l-.158-.086a4.421,4.421,0,0,0-2.85-.543,8.616,8.616,0,0,0-.943.72c-2.878,1.1-4.094,4.569-4.094,4.569l-.752-.1-.306-.036a10.308,10.308,0,0,1,3.6-4.882c1.576-1.3,4.17-.91,5.282-.662.335.076.532.137.532.137Z",
    transform: "translate(-358.055 -92.006)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M586.2,150.343a6,6,0,0,0-.8-1.2,2.854,2.854,0,0,0-.777-.615c.338.05.594.1.72.119A7.1,7.1,0,0,1,586.2,150.343Z",
    transform: "translate(-374.285 -94.237)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M565.578,141.524c-1.112-.248-3.706-.637-5.281.662a10.357,10.357,0,0,0-3.6,4.882l-.187-.025-.335,1.079q-.417-.061-.917-.162c.036-.072,2.724-5.037,4.051-7.062v-.687l.14-.047c.68-.23,3.652-1.191,4.749-.932a.862.862,0,0,1,.137.043A25.23,25.23,0,0,0,565.578,141.524Z",
    transform: "translate(-355.488 -88.256)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M553.808,172.542h-.561a8.332,8.332,0,0,1-1.565-.191l-.162-.04-.22-.065a15.47,15.47,0,0,1-.7-4.058,5.217,5.217,0,0,1,.813-2.878c.061.036.137.072.223.115a4.012,4.012,0,0,0,1.925.385,2.436,2.436,0,0,0-.086.306A12.754,12.754,0,0,0,553.808,172.542Z",
    transform: "translate(-352.503 -104.98)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M556.15,174.308a8.069,8.069,0,0,1-2.518-.3c-.022-.072-.04-.14-.061-.209a8.731,8.731,0,0,0,2.126.194,12.716,12.716,0,0,1-.335-6.415,3.636,3.636,0,0,0,.525,0A12.829,12.829,0,0,0,556.15,174.308Z",
    transform: "translate(-354.406 -106.433)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M578.474,231.4a.039.039,0,0,1-.032,0l-4.469-3.868a.05.05,0,0,1,0-.072l.522-.648a.043.043,0,0,1,.036,0,.054.054,0,0,1,.039,0l4.109,4.343a.047.047,0,0,1,0,.036.064.064,0,0,1,0,.036l-.176.162A.039.039,0,0,1,578.474,231.4Zm-4.389-3.914,4.386,3.8.1-.1-4.037-4.263Z",
    transform: "translate(-367.459 -144.353)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M577.392,307.995h0a.05.05,0,0,1-.043-.058,45.633,45.633,0,0,0,.507-4.843.044.044,0,0,1,.054-.047.047.047,0,0,1,.047.05,45.806,45.806,0,0,1-.507,4.857A.054.054,0,0,1,577.392,307.995Z",
    transform: "translate(-369.629 -193.162)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M578.107,307.01h0a.05.05,0,0,1-.033-.022.051.051,0,0,1-.007-.039c.018-.076.45-1.846,3.9-5.933a.05.05,0,0,1,.068.072c-3.432,4.062-3.878,5.872-3.882,5.89A.047.047,0,0,1,578.107,307.01Z",
    transform: "translate(-370.089 -191.853)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M568.236,286.721a2.652,2.652,0,0,1-.273.457l-.061.086-.219.047a7.459,7.459,0,0,1-1.32-.3,1.713,1.713,0,0,1-.608-.327c-.176-.453-.486-1.475-.486-1.475l.428-1.079c.126-3.3-2.367-25.023-2.612-26.264a21.364,21.364,0,0,0-.982-3.314,15.428,15.428,0,0,1,.094-2.036,4.545,4.545,0,0,1-.338-1.061c-.065-1.112-.892-5.123-.892-5.123l-.547-.644c.083-2.4-.148-8.045-.148-8.045l.036.043a45.464,45.464,0,0,0,1.2,6.181c.849,2.731,3.144,8.89,3.144,8.89s.025,1.918.122,2.6l.464.928s1.22,7.8,1.22,9.8l-.212,1.72a126.653,126.653,0,0,1,2.029,16.6l-.576,1.723A4.884,4.884,0,0,0,568.236,286.721Z",
    transform: "translate(-358.695 -151.287)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M574.111,378.3h-13.1a.72.72,0,0,1-.1-.792c4.638-.025,6.634-1.939,7.35-2.9l.061-.086a2.654,2.654,0,0,0,.273-.457h0l.119.108a3.2,3.2,0,0,0,.432.32,1.565,1.565,0,0,0,.536.219,5.428,5.428,0,0,0,1.579-.18c.489-.1,1.022-.234,1.507-.36.309.676.831.907,1.133,1.572A4.129,4.129,0,0,1,574.111,378.3Z",
    transform: "translate(-359.059 -238.626)",
    fill: "#2c0600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M574.353,386.062a.223.223,0,0,1-.212.212H561.275a.212.212,0,0,1-.151-.36.216.216,0,0,1,.151-.065h12.862a.216.216,0,0,1,.216.212Z",
    transform: "translate(-359.204 -246.174)",
    fill: "#2c0600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M557.86,378.019a.72.72,0,0,0,.1.792h-1.716a.72.72,0,0,1-.1-.792c4.638-.025,6.638-1.939,7.35-2.9a3.046,3.046,0,0,0,.176-.255,7.457,7.457,0,0,0,1.32.3l.219-.047C564.494,376.08,562.5,377.994,557.86,378.019Z",
    transform: "translate(-356.005 -239.138)",
    fill: "#160300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M558.218,386.238h-1.713a.216.216,0,0,1-.216-.212.223.223,0,0,1,.216-.216h1.712a.216.216,0,0,0-.212.216A.212.212,0,0,0,558.218,386.238Z",
    transform: "translate(-356.147 -246.148)",
    fill: "#160300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M570.811,132.135a3.407,3.407,0,0,0-1.133,0,22.1,22.1,0,0,0-3.616.925,3.886,3.886,0,0,0-.094-1.392,2.925,2.925,0,0,1-.388-.1l.058-.867.032-.453c.813-.187,1.914-.464,2.993-.817l.759-1.346c.122.36.417.608,1.187,1.126A7.7,7.7,0,0,0,570.811,132.135Z",
    transform: "translate(-362.095 -81.145)",
    fill: "#f8957e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M570.914,132.135a3.407,3.407,0,0,0-1.133,0,8.69,8.69,0,0,1-.68-2.252,11.2,11.2,0,0,1-3.36.813l.032-.453c.813-.187,1.914-.464,2.993-.817l.759-1.346c.122.36.417.608,1.187,1.126a7.7,7.7,0,0,0,.2,2.929Z",
    transform: "translate(-362.197 -81.145)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M570.194,192.849l-1.4,2.062-.029,1.972a37.178,37.178,0,0,1-8.433,9.714,2.505,2.505,0,0,0-.047-.324c-.014-.108-.022-.176-.036-.259,2.544-2.6,6.055-6.476,7.242-9.066l.061-1.6s.845-.792.964-.91a4.063,4.063,0,0,0,.025-1.191s.072-.234.187-.63c.068-.241.158-.547.255-.892.029-.108.061-.219.094-.335v-.022c.043-.158.09-.317.133-.482.022-.068.043-.14.061-.209s0-.072.029-.108l.032-.119a.515.515,0,0,1,.04-.14c.014-.047,0-.043.018-.068l.032-.108v-.022l.054-.2.216-.792.05-.191a.425.425,0,0,0,0-.065.738.738,0,0,1,.05-.194c.018-.065,0-.043,0-.065C569.874,190.007,570.043,191.59,570.194,192.849Z",
    transform: "translate(-358.683 -119.891)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M576.989,153.826a26.029,26.029,0,0,1-.759,5.8h-2.385l-.191-.022-.295-.036h-.151l-.155-.022-.317-.05-.223-.036h-.1l-.216-.043h0l-.194-.036-.2-.043-.407-.094-.119-.029-.234-.061-.1-.029-.133-.036h-.025l-.155-.047h-.18l-.18-.054-.183-.061-.1-.036-.083-.029-.155-.054-.219-.079-.176-.068c-.151-.058-.3-.119-.453-.187,4.109.989,6.2.187,6.2.187l.1-2.544c.065-6.055-3.184-9.092-3.184-9.092a5.944,5.944,0,0,1,2.371.626l.162.086a3.039,3.039,0,0,1,.774.615,5.853,5.853,0,0,1,.8,1.2A8.391,8.391,0,0,1,576.989,153.826Z",
    transform: "translate(-364.214 -93.277)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M559.7,161.541v.845l-1.414-.119.263-.878.18.025Z",
    transform: "translate(-357.428 -102.47)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M559.7,162.347v.04l-1.414-.119.263-.878.18.025-.234.8Z",
    transform: "translate(-357.428 -102.47)",
    fill: "#f7ddce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M520.985,179.842l-.054.04-.514.4s-.558.921-.72.946-1.313.173-1.313.173l-.989,1.266c-2.486,1.41-7.595,2.482-11.182,3.1-1.8.306-3.191.5-3.706.568a2.4,2.4,0,0,0-.317-1.9l.428-.176.2,1.576,10.57-2.644,4.8-3.13,2.051-.324a39.638,39.638,0,0,1-1.205-5.634l.043-.054.532-.72a15.475,15.475,0,0,0,.7,4.058l.219.065v.094C520.729,178.478,520.873,179.234,520.985,179.842Z",
    transform: "translate(-321.511 -110.115)",
    fill: "#d1625b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M588.256,298.591s-.752.223-1.666.461a11.8,11.8,0,0,1-3.087.54,2.158,2.158,0,0,1-.968-.54l-.115-.1h0l2.371-.792,2.274-1.968-2.277-6.735,2.6-4.379-.327-17.475-1.313-1.853.22-9.016.72,7.264L588,266.451c.813,4.317.4,18.874.4,18.874a15.052,15.052,0,0,1,.813,4.148C589.522,292.517,588.256,298.591,588.256,298.591Z",
    transform: "translate(-372.876 -163.509)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M565.953,106.624a1.065,1.065,0,0,1-1.439.417,1.441,1.441,0,0,1-.414-.263,3.274,3.274,0,0,1,1.252-1.439A1.079,1.079,0,0,1,565.953,106.624Z",
    transform: "translate(-361.147 -66.586)",
    fill: "#fffaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M140.423,266.716v6.066H0V211.81H16a1.554,1.554,0,0,1,1.554,1.551v6.073h16a1.551,1.551,0,0,1,1.551,1.554v6.07h16a1.551,1.551,0,0,1,1.551,1.551v6.07h16a1.551,1.551,0,0,1,1.551,1.554v6.07h16a1.554,1.554,0,0,1,1.554,1.551v6.07h16a1.551,1.551,0,0,1,1.551,1.554v6.069h16a1.551,1.551,0,0,1,1.551,1.551v6.066h16.007a1.551,1.551,0,0,1,1.547,1.554Z",
    transform: "translate(0 -134.75)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M66.6,87.581V139.3h-2V86.66Z",
    transform: "translate(-41.358 -54.627)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M207.364,152.087v51.384h-2v-52.3Z",
    transform: "translate(-131.475 -95.927)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M348.124,216.607v50.959h-2V215.69Z",
    transform: "translate(-221.593 -137.234)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M134.27,114.048a.914.914,0,0,1-.827.529.871.871,0,0,1-.36-.083L.05,53.53V51.54l133.77,61.328A.9.9,0,0,1,134.27,114.048Z",
    transform: "translate(-0.032 -32.142)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M64.6,86.66l2,.921v4.073l-2-.925Z",
    transform: "translate(-41.358 -54.627)",
    fill: "#8e344e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M205.36,151.17l2,.917V156.2l-2-.921Z",
    transform: "translate(-131.475 -95.927)",
    fill: "#8e344e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M348.124,216.607v4.152l-2-.917V215.69Z",
    transform: "translate(-221.593 -137.234)",
    fill: "#8e344e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M140.473,381.27v5.4a1.543,1.543,0,0,1-.752,1.328H.05V381.27Z",
    transform: "translate(-0.032 -243.242)",
    opacity: 0.2,
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957",
    transform: "translate(200.063 140.09)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M582.43,400Z",
    transform: "translate(-572.945 -395.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M586.992,398.854H582.43a1.429,1.429,0,0,1,.112-.1,2.79,2.79,0,0,1,.59-.41l.119-.054a1.656,1.656,0,0,1,.259-.079h.094a7.9,7.9,0,0,1,1.781.259l.205.043.1.025.245.057H586l.2.05h.029l.36.094Z",
    transform: "translate(-572.945 -394.177)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M578.079,398.963H575.65a1.875,1.875,0,0,1,.558-.284,7.65,7.65,0,0,1,1.32-.3l.219.043.065.09A2.961,2.961,0,0,1,578.079,398.963Z",
    transform: "translate(-568.605 -394.286)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M573.936,390.787c-.3.669-.82.9-1.13,1.572l-.36-.094h-.029l-.2-.05h-.058l-.245-.058-.1-.025-.205-.043a7.894,7.894,0,0,0-1.781-.259h-.09a1.381,1.381,0,0,0-.263.079l-.119.054a2.79,2.79,0,0,0-.59.41,1.413,1.413,0,0,0-.112.1h0a2.953,2.953,0,0,0-.266-.45l-.065-.09c-.72-.964-2.713-2.878-7.354-2.9a.719.719,0,0,1,.1-.792h13.1A4.217,4.217,0,0,1,573.936,390.787Z",
    transform: "translate(-559.156 -387.794)",
    fill: "#2c0600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M574.35,387.242a.209.209,0,0,0-.065-.151.2.2,0,0,0-.148-.061H561.272a.212.212,0,1,0,0,.425h12.862a.212.212,0,0,0,.216-.212Z",
    transform: "translate(-559.264 -387.019)",
    fill: "#2c0600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M557.86,389a.72.72,0,0,1,.1-.792h-1.716a.72.72,0,0,0-.1.792c4.638.029,6.638,1.939,7.35,2.9.072.1.13.184.176.255a7.654,7.654,0,0,1,1.32-.3l.219.043C564.494,390.941,562.5,389.03,557.86,389Z",
    transform: "translate(-556.067 -387.775)",
    fill: "#160300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M558.225,387h-1.712a.212.212,0,1,0,0,.424h1.712a.212.212,0,1,1,0-.425Z",
    transform: "translate(-556.216 -387)",
    fill: "#160300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M582.43,400Z",
    transform: "translate(-572.945 -395.323)",
    fill: "#e37c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M586.992,398.854H582.43a1.429,1.429,0,0,1,.112-.1,2.79,2.79,0,0,1,.59-.41l.119-.054a1.656,1.656,0,0,1,.259-.079h.094a7.9,7.9,0,0,1,1.781.259l.205.043.1.025.245.057H586l.2.05h.029l.36.094Z",
    transform: "translate(-572.945 -394.177)",
    fill: "#e37c00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    transform: "translate(95.302 138.453)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M284.023,388.764H264.89c.36-1.986,2.238-3.731,3.49-5.994a16.548,16.548,0,0,1,4.181-.32h1.9c3.357,0,6.077.151,6.077.335C281.782,385.03,283.656,386.771,284.023,388.764Z",
    transform: "translate(-264.89 -382.45)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M297.686,388.764h-8.275a13.122,13.122,0,0,0-.827-3.015,10.433,10.433,0,0,0-1.457-2.472,3.092,3.092,0,0,0-.9-.827h1.9c3.357,0,6.077.151,6.077.335C295.444,385.03,297.318,386.771,297.686,388.764Z",
    transform: "translate(-278.552 -382.45)",
    fill: "#88687f",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M280.414,349.579c0,.425-2.724.766-6.077.766-.662,0-1.3,0-1.9-.036-2.428-.1-4.181-.389-4.181-.72-1.7-7.019-4.555-11.837-3.206-18.86H283.62C284.958,337.742,282.113,342.56,280.414,349.579Z",
    transform: "translate(-169.469 -210.885)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M284.245,328.229c0,.684-3.378,1.252-7.8,1.356h-1.479c-5.127,0-9.282-.615-9.282-1.374s4.155-1.371,9.282-1.371S284.245,327.473,284.245,328.229Z",
    transform: "translate(-170.093 -208.395)",
    fill: "#fffbf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M285.279,328.933c0,.522-3.184.953-7.25,1h-1.414c-4.062-.043-7.246-.475-7.246-1s3.206-.953,7.286-.993h1.335C282.074,327.98,285.279,328.411,285.279,328.933Z",
    transform: "translate(-172.456 -209.099)",
    fill: "#88687f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M290.924,298.066H289.51l.04-1.99.079-4.065v-.622l.061-3.209.072-3.58.079-4.148.047-2.281h.633l.043,2.263.094,4.634.058,3.1.061,3.04v.6l.083,4.267Z",
    transform: "translate(-185.35 -177.235)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M281.484,253.3c-.029.4-.072.792-.13,1.184h0c-.029.184-.058.36-.09.55a11.179,11.179,0,0,1-.748,2.547,5.847,5.847,0,0,1-1.838,2.432c-.126.094-.259.18-.4.263a5.235,5.235,0,0,1-.622.306,7.191,7.191,0,0,1-.989.32h0l-.1.025h0c-.428.1-.863.18-1.3.255-1.259.223-2.518.443-3.781.572-.748.076-1.5.115-2.256.133h-1.025c-1.177,0-2.349-.043-3.526-.083-.284,0-.572-.025-.856-.047a5.285,5.285,0,0,1-1.587-.327l-.086-.036a6.565,6.565,0,0,1-1.95-1.486,15.618,15.618,0,0,1-3-3.724,9.858,9.858,0,0,1-.856-2.339c-.061-.248-.115-.5-.158-.756a17.522,17.522,0,0,1-.234-2.339c0-.263,0-.522-.022-.781v-1.162a18.193,18.193,0,0,1,.148-2.123.557.557,0,0,1,0-.076,9.1,9.1,0,0,1,.313-1.421,9.948,9.948,0,0,1,1.587-2.972h0c.147-.2.3-.392.461-.579l.291-.36c.1-.126.2-.252.313-.381,1.148-1.4,2.652-3.087,4.353-3.278.8-.086,1.626-.2,2.465-.3l.943-.094a16.811,16.811,0,0,1,3.9.022,8.938,8.938,0,0,1,1.533.36c.241.076.475.165.72.259a9.714,9.714,0,0,1,4.476,3.706q.187.291.36.594c.115.209.227.414.331.626.047.1.1.194.14.291.122.241.237.486.36.72l.158.331q.648,1.385,1.3,2.77c0,.029.025.058.036.083.115.245.23.489.342.72s.245.554.36.838.184.493.259.741c.018.058.032.108.05.162A10.957,10.957,0,0,1,281.484,253.3Z",
    transform: "translate(-163.858 -150.963)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M260.27,247.983a2.594,2.594,0,0,0,.666-.083.593.593,0,0,1,.273-.029.5.5,0,0,1,.3.259,2.4,2.4,0,0,1,.306.644c.108.36-.032,1.745-.72,1.158-.227-.194-.234-.673-.36-.939A2.878,2.878,0,0,1,260.27,247.983Z",
    transform: "translate(-166.63 -157.834)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M317.293,253.923h0a.449.449,0,0,1-.1.309.855.855,0,0,1-.953-.043c-.248-.252-.137-.738-.018-1.04,0-.025.022-.047.032-.068a1.229,1.229,0,0,1,.18-.291,1.246,1.246,0,0,1,.219-.216,1.108,1.108,0,0,1,.4-.183,1.361,1.361,0,0,0,0,.27,9.985,9.985,0,0,1,.241,1.263Z",
    transform: "translate(-202.365 -160.73)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M256.979,279.29a.062.062,0,0,1,0,.025,1.227,1.227,0,0,1-.3.72.6.6,0,0,1-.525.158.392.392,0,0,1-.216-.119c-.108-.115-.158-.306-.313-.36a.4.4,0,0,0,.3-.18.793.793,0,0,0,.068-.108c.151-.3.173-.72.392-.975a.536.536,0,0,1,.252-.162C257.173,278.142,257.015,279,256.979,279.29Z",
    transform: "translate(-163.659 -177.301)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M274.415,302.176a.914.914,0,0,1-.169.425.615.615,0,0,1-.158.162,1.439,1.439,0,0,1-.986.155l-.892-.072a3.615,3.615,0,0,0,.45-.572c.047-.076.09-.155.13-.234a1.529,1.529,0,0,0,.147-.756c0-.255.191-.331.432-.36a.878.878,0,0,1,.568.05.935.935,0,0,1,.4.536,1.467,1.467,0,0,1,.083.666Z",
    transform: "translate(-174.274 -191.786)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M313.444,300.677a1.86,1.86,0,0,0-.076.227,2.222,2.222,0,0,0-.086.435h-.414a1.687,1.687,0,0,1-.489-.1h0a1.079,1.079,0,0,1-.6-.45.378.378,0,0,1,0-.428.925.925,0,0,1,.748-.248l.36.029h.187a.947.947,0,0,1,.248.047.284.284,0,0,1,.173.173A.453.453,0,0,1,313.444,300.677Z",
    transform: "translate(-199.566 -191.276)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M325.911,282.027a.788.788,0,0,1-.453.288,1.031,1.031,0,0,1-.205.04h0a.752.752,0,0,1-.486-.083c-.191-.1-.36-.41-.191-.6.065-.083.2-.1.291-.148a1.939,1.939,0,0,0,.432-.291l.083-.065.612-.507c0,.263,0,.525.018.784A1,1,0,0,1,325.911,282.027Z",
    transform: "translate(-207.755 -178.829)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M284.285,236.711a.438.438,0,0,1,0,.1.864.864,0,0,1-.313.468.482.482,0,0,1-.068.05.307.307,0,0,1-.086.032c-.194.054-.543.147-.612-.133a.536.536,0,0,1,.144-.421.806.806,0,0,1,.191-.169,1.754,1.754,0,0,1,.36-.133.54.54,0,0,0,.3-.212,1.181,1.181,0,0,1,.09.421Z",
    transform: "translate(-181.312 -150.423)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M301.861,238.328a.2.2,0,0,1-.119.176.575.575,0,0,1-.219.05c-.169.018-.425.029-.468-.183a.547.547,0,0,1,.09-.36,1.463,1.463,0,0,1,.173-.252.382.382,0,0,0,.184.266c.068.043.147.061.223.1a.259.259,0,0,1,.133.144.133.133,0,0,1,0,.058Z",
    transform: "translate(-192.739 -151.364)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M254.371,262.36a.486.486,0,0,0,.1.414c.13.115.331.058.5.076a.759.759,0,0,1,.554.36,1.983,1.983,0,0,1,.245.637.932.932,0,0,1-.288,1.079c-.338.263-.586.191-.784-.176A3.173,3.173,0,0,1,254.371,262.36Z",
    transform: "translate(-162.789 -167.113)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M323.139,264.617a.5.5,0,0,1-.284.36l-.061.025c-.281.1-.72-.058-.633-.421.029-.151.183-.263.36-.342a4.1,4.1,0,0,1,.392-.155c.068-.029.165-.047.2.022a.2.2,0,0,1,0,.1C323.1,264.354,323.153,264.487,323.139,264.617Z",
    transform: "translate(-206.246 -168.201)",
    fill: "#6b711b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M280.312,281.836a5.847,5.847,0,0,1-1.839,2.432c-.126.094-.259.18-.4.263a5.252,5.252,0,0,1-.622.306,2.217,2.217,0,0,0-.086.435h-.414a1.685,1.685,0,0,1-.489-.1h0l-.1.025h0c-.428.1-.863.18-1.3.255-1.259.223-2.518.443-3.781.572-.748.076-1.5.115-2.256.133h-1.025c-1.177,0-2.349-.043-3.526-.083-.284,0-.572-.025-.856-.047a.615.615,0,0,1-.158.162,1.439,1.439,0,0,1-.986.155l-.892-.072a3.625,3.625,0,0,0,.45-.572l-.086-.036a6.566,6.566,0,0,1-1.95-1.486,15.619,15.619,0,0,1-3-3.724,9.858,9.858,0,0,1-.856-2.339.392.392,0,0,1-.216-.119c-.108-.115-.158-.306-.313-.36a.4.4,0,0,0,.3-.18.8.8,0,0,0,.068-.108,17.522,17.522,0,0,1-.234-2.346,7.008,7.008,0,0,0,.633,1.364,6.775,6.775,0,0,0,.586.842l.022.029c.079-.14.158-.281.234-.425a11.12,11.12,0,0,0,2.623,3.6c.072-.126.151-.255.227-.381,1.3,1.835,3.655,2.536,5.85,3.044a3.285,3.285,0,0,0,1.18.119,1.144,1.144,0,0,0,.932-.651l.043.022.9.468.41.219a.576.576,0,0,0,.461.086,1.809,1.809,0,0,0,.241-.176c.338-.209.72.155,1.025.417a4.714,4.714,0,0,0,3.145.759,14.419,14.419,0,0,0,1.626-.054,5.809,5.809,0,0,0,.86-.151l.234-.068h0a3.238,3.238,0,0,0,1.8-1.288,4.286,4.286,0,0,0,1.529-.935Z",
    transform: "translate(-163.653 -175.206)",
    fill: "#646019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M284.113,242.34c-.09.072-.18.14-.277.205a3.141,3.141,0,0,1-.572.284,3.569,3.569,0,0,1-.6.173,2.745,2.745,0,0,0-.36-1.439c-.414-.435-.162.094-.54.054s-.439-.655-.543-.943a2.947,2.947,0,0,0-.968-1.461,7.541,7.541,0,0,0-5.469-1.079c-.234.558,0,1.281-.306,1.8-.36.608-.986.468-1.572.5-1.346.083-.655,2.428-1.756,2.292-.525-.068-.968-.6-1.493-.72a1.8,1.8,0,0,0-1.281.2c-.568.3-.774.428-1.31-.022-.4-.331-.475-.86-1-.759s-.788.565-1.137,0a2.159,2.159,0,0,1-.306-1.079c1.148-1.4,2.652-3.087,4.353-3.278.8-.086,1.626-.2,2.465-.3a.807.807,0,0,1,.191-.169,1.754,1.754,0,0,1,.36-.133.54.54,0,0,0,.3-.212,1.181,1.181,0,0,1,.112.421,16.812,16.812,0,0,1,3.9.022,8.942,8.942,0,0,1,1.533.36,1.459,1.459,0,0,1,.173-.252.381.381,0,0,0,.183.266c.068.043.147.061.223.1a.259.259,0,0,1,.133.144,9.715,9.715,0,0,1,4.476,3.706q.187.291.36.594c.115.209.227.414.331.626a1.109,1.109,0,0,1,.4-.183A1.358,1.358,0,0,0,284.113,242.34Z",
    transform: "translate(-169.415 -150.404)",
    fill: "#b2be1a",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M295.168,256.173c.27-.036.5.183.68.385l1.115,1.234a.719.719,0,0,0,.36.252.687.687,0,0,0,.36-.076l1.083-.421a.309.309,0,0,1,.417.2l.2.658a.32.32,0,0,0,.313.223l.525-.018a.313.313,0,0,1,.291.453,1.284,1.284,0,0,0-.245.68.861.861,0,0,0,.147.338l.27.432a.317.317,0,0,1-.331.475h0a.313.313,0,0,0-.36.194c-.2.5-.421,1-.651,1.5a.313.313,0,0,1-.583-.029l-.05-.14a.36.36,0,0,0-.115-.187.334.334,0,0,0-.23-.022l-2.018.27a.317.317,0,0,1-.36-.36,2.948,2.948,0,0,1,.072-.389.316.316,0,0,0-.216-.385,5.807,5.807,0,0,1-.64-.212.471.471,0,0,1-.252-.676c.029-.05.032-.129-.022-.27-.1-.288-.515-.3-.68-.525-.216-.306-.09-.457.122-.72a3.831,3.831,0,0,0,.745-.939A15.912,15.912,0,0,0,295.168,256.173Z",
    transform: "translate(-188.313 -163.15)",
    fill: "#b2be1a",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M281.484,270.178c-.029.4-.072.792-.13,1.184h0c-.029.184-.058.36-.09.55a11.179,11.179,0,0,1-.748,2.547,5.847,5.847,0,0,1-1.838,2.432c-.126.094-.259.18-.4.263a5.249,5.249,0,0,1-.622.306,7.2,7.2,0,0,1-.989.32h0l-.1.025h0c-.428.1-.863.18-1.3.255-1.259.223-2.518.443-3.781.572-.748.076-1.5.115-2.256.133h-1.025c-1.177,0-2.349-.043-3.526-.083-.284,0-.572-.025-.856-.047a5.286,5.286,0,0,1-1.587-.327l-.086-.036a6.566,6.566,0,0,1-1.95-1.486,15.618,15.618,0,0,1-3-3.724,9.858,9.858,0,0,1-.856-2.339c-.061-.248-.115-.5-.158-.756a17.521,17.521,0,0,1-.234-2.339c0-.263,0-.522-.022-.781v-1.162a18.192,18.192,0,0,1,.148-2.123.557.557,0,0,1,0-.076,2.63,2.63,0,0,0,.72.878,2.011,2.011,0,0,0,2.439-.1l.928,2.216a2.486,2.486,0,0,0,.745,1.137.865.865,0,0,0,1.216-.137,23.928,23.928,0,0,0,1.079,2.4l2.72-.9a3.428,3.428,0,0,1-1.159,1.8,5.08,5.08,0,0,0,5.472-1.079,1.846,1.846,0,0,1-.72,2.141c.309.4.637.788.982,1.159a.651.651,0,0,0,.36.241.666.666,0,0,0,.453-.144l1.7-1.025a3.792,3.792,0,0,0,1.59,1.439,4.087,4.087,0,0,0-.266-2.45,1.551,1.551,0,0,1,1.72,1.515,1.608,1.608,0,0,0,.989-1.245l1.508-.133a5.454,5.454,0,0,0,1.651-6.077,2.615,2.615,0,0,1,.59.324c.094.245.184.493.259.741.018.058.032.108.05.162A10.954,10.954,0,0,1,281.484,270.178Z",
    transform: "translate(-163.858 -167.837)",
    fill: "#646019",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M294.183,349.541c0,.425-2.724.766-6.077.766-.662,0-1.3,0-1.9-.036a6.934,6.934,0,0,0,.9-1.885,38.2,38.2,0,0,0,1.457-5.641,73.87,73.87,0,0,0,1.018-10.434v-.284c4.425-.1,7.8-.673,7.8-1.356C298.727,337.7,295.881,342.521,294.183,349.541Z",
    transform: "translate(-183.237 -210.847)",
    fill: "#88687f",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M28.286,124.488l-2.162,66.175-.748,22.9h-.953l.5,2.137H23.756l-1.95-2.137H10.091l.5,2.137H9.426l-1.95-2.137H.05v-91l14.665.219,3.648.461Z",
    transform: "translate(-0.032 -77.611)",
    fill: "#fefcc3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(0.018 44.949)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M14.715,122.779l-2.961,90.784H.05v-91Z",
    transform: "translate(-0.05 -122.56)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M11.772,135l-1.266,59.547-.766,24.821H.05V134.9l9.29.083Z",
    transform: "translate(-0.05 -130.46)",
    fill: "#87bbcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M49.112,124.879,46.95,191.054l-.748,22.9H32.58l2.961-90.784,3.648.461Z",
    transform: "translate(-20.876 -122.951)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M62.47,377.637h1.166l-.5-2.137H60.52Z",
    transform: "translate(-38.764 -284.497)",
    fill: "#253b60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M22.64,377.637h1.166l-.5-2.137H20.69Z",
    transform: "translate(-13.264 -284.497)",
    fill: "#427391"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(0 4.44)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M9.34,134.983.05,157.829V134.9Z",
    transform: "translate(-0.05 -134.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M46.95,191.054l-.748,22.9H32.58l2.961-90.784,3.648.461-2.716,61.343Z",
    transform: "translate(-20.876 -122.951)",
    fill: "#427391",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(0.018 138.089)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M25.523,388.11H.05v-4.533H7.476l1.95-2.137h1.166l-.5,2.137H21.806l1.95-2.137h1.166l-.5,2.137h.953Z",
    transform: "translate(-0.05 -381.44)",
    fill: "#fefcc3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M11.9,391.913H.05V387.38h11.7Z",
    transform: "translate(-0.05 -385.243)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M9.814,395.633H.05V393.19H9.739Z",
    transform: "translate(-0.05 -388.963)",
    fill: "#87bbcd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M46.349,391.913H32.728l-.148-4.533H46.2Z",
    transform: "translate(-20.876 -385.243)",
    fill: "#69aac0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M62.47,381.44h1.166l-.5,2.137H60.52Z",
    transform: "translate(-38.764 -381.44)",
    fill: "#253b60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M22.64,381.44h1.166l-.5,2.137H20.69Z",
    transform: "translate(-13.264 -381.44)",
    fill: "#427391"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M46.349,391.913H32.728l-.148-4.533H46.2Z",
    transform: "translate(-20.876 -385.243)",
    fill: "#427391",
    opacity: 0.25
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M88.966,267.217l-.259,2.313-.489,4.339L88,275.791l-.2,1.763H64.018l-.536,1.547H61.568l.1-1.54h-12.4l-.043.2-.151.63-.155.72h-2.08l.076-1.547H26.734l-.54,1.547h-1.91l.094-1.547h-.284a.932.932,0,0,1-.86-1.3c2.666-6.314,1.59-12.592-.36-17.568a91.615,91.615,0,0,1-5.44-20.993q-.453-3.3-.684-6.613l-.223-3.2a2.723,2.723,0,0,1,.119-1.015,2.792,2.792,0,0,1,.881-1.32,21.392,21.392,0,0,1,2.119-1.716h0a20.172,20.172,0,0,1,3.868-2.159v4.073h16a1.554,1.554,0,0,1,1.554,1.554v6.07H51.9C54.3,245.292,64.77,254.6,77.089,254.6,84.224,254.6,89.768,260.123,88.966,267.217Z",
    transform: "translate(-10.577 -141.069)",
    fill: "#253b60",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M206.874,376.98l-.18.838-.155.712h-2.08l.058-1.551Z",
    transform: "translate(-130.899 -240.495)",
    fill: "#253b60",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M9.58,225.581l1.986,10.642.745,3.986,1.266,1.04,11.265,9.228,7.063,5.789s7.937,4.105,8.124,3.958a52.263,52.263,0,0,1,5.242.119l.979,14.2H80.367l.2-1.763.216-1.921.489-4.339.259-2.313c.8-7.095-4.742-12.621-11.873-12.621-13.2,0-24.282-10.693-25.566-23.828l-.032-.331c-.029-.3-.068-.6-.126-.9A8.995,8.995,0,0,0,40.4,220.94a8.382,8.382,0,0,0-.72-.482,8.923,8.923,0,0,0-1.13-.561c-6.4-2.608-17.417-5.4-26.322.91h0a21.487,21.487,0,0,0-2.141,1.727Z",
    transform: "translate(-6.133 -138.056)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M8.22,234.771l.219,3.2q.23,3.321.684,6.613a91.345,91.345,0,0,0,5.444,20.993c1.95,4.965,3.026,11.254.36,17.568a.932.932,0,0,0,.86,1.306h30l.9-8.023.259-2.313A11.97,11.97,0,0,0,35.056,260.8h0a25.977,25.977,0,0,1-4.637-.417A25.706,25.706,0,0,1,11.9,246.248c-.094-.183-.18-.36-.263-.561A25.4,25.4,0,0,1,9.5,237.66c-.306-3.123-.237-5.217-.277-5.22a2.767,2.767,0,0,0-.881,1.32A2.724,2.724,0,0,0,8.22,234.771Z",
    transform: "translate(-5.259 -147.958)",
    fill: "#842f47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M195.51,384.776h.953l1.511-6.951.18-.835H195.8Z",
    transform: "translate(-125.169 -240.502)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M132.87,381.865h.953l1.695-4.875h-2.357Z",
    transform: "translate(-85.066 -240.502)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M91.87,384.779h.953l1.695-7.789H92.161Z",
    transform: "translate(-58.817 -240.502)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M29.24,381.865h.953l1.691-4.875H29.528Z",
    transform: "translate(-18.72 -240.502)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M51.039,273.724l-.259,2.31-.36,3.209-.486,4.317a2.18,2.18,0,0,1-2.159,1.946l.72-6.242.2-1.781.266-2.313a11.9,11.9,0,0,0-.9-6.062,12.064,12.064,0,0,0-2.608-3.806,12.212,12.212,0,0,0-1.554-1.3l-.205-.14a11.874,11.874,0,0,0-3.479-1.583L40,262.225c-.14-.036-.277-.068-.417-.1a12.1,12.1,0,0,0-2.518-.263h0a25.582,25.582,0,0,1-4.634-.424h-.083l-.45-.086-.586-.126a.134.134,0,0,0-.036,0q-.54-.124-1.079-.27h-.025c-.248-.068-.493-.144-.72-.219-.09-.029-.183-.054-.273-.086l-.457-.151-.36-.126a25.867,25.867,0,0,1-3.454-1.54l-.288-.158c-.133-.072-.263-.148-.392-.223s-.191-.112-.284-.169c-.241-.14-.479-.288-.72-.443-.115-.068-.227-.144-.338-.219l-.23-.155-.309-.212c-.568-.4-1.115-.81-1.644-1.248l-.3-.252-.169-.144-.241-.212c-.309-.277-.615-.561-.914-.856l-.273-.27c-.6-.608-1.173-1.248-1.713-1.914l-.183-.227a25.752,25.752,0,0,1-2.3-3.447l-.148-.273c-.191-.36-.36-.72-.547-1.079-.094-.184-.18-.36-.263-.561a25.426,25.426,0,0,1-2.137-8.027c-.04-.41-.076-.806-.1-1.176-.018-.248-.036-.486-.05-.72s0-.36-.029-.536v-.36c-.025-.518-.036-.964-.043-1.328v-.536c.194,3.425,1.993,20.91,18.849,24.879l2.788.68a25.61,25.61,0,0,0,6.293.777h0c.2,0,.4,0,.6.018h.126c.385.022.763.065,1.137.119l.3.058a11.732,11.732,0,0,1,2.677.82c.327.147.648.306.961.478l.166.094.108.065a3.854,3.854,0,0,1,.36.23h0l.216.144.212.148.187.13.079.065c.1.068.194.14.288.216l.119.1.151.126c.1.086.205.173.3.266s.187.165.277.252l.158.162c.115.115.227.23.338.36a11.938,11.938,0,0,1,2.7,4.76.426.426,0,0,0,.036.122,11.9,11.9,0,0,1,.317,4.569Z",
    transform: "translate(-7.228 -149.014)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M195.51,384.776l.957-6.951h1.507l.18-.835H195.8Z",
    transform: "translate(-125.169 -240.502)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M91.87,384.776l.957-6.951h1.507l.183-.835H92.161Z",
    transform: "translate(-58.817 -240.502)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M81.312,262.675a8.563,8.563,0,0,0-7.865-7.487h-.025c-11.006-.568-16.715-2.256-19.453-3.447-11.283-9.4-10.434-17.547-10.272-22.555a13.445,13.445,0,0,0-2.385-8.246,8.381,8.381,0,0,0-.72-.482,8.923,8.923,0,0,0-1.13-.561c-6.393-2.608-17.417-5.4-26.322.91h0A20.988,20.988,0,0,0,11,222.534a3.857,3.857,0,0,1,.018.529.273.273,0,0,0,0,.054c.194,3.425,1.993,20.91,18.849,24.879l2.788.68a25.614,25.614,0,0,0,6.293.777h0c.2,0,.4,0,.6.018h.126c.385.022.763.065,1.137.119l.3.058a11.732,11.732,0,0,1,2.677.82c.327.148.648.306.961.479l.165.094.108.065a3.865,3.865,0,0,1,.36.23h0c.072.043.144.094.216.144l.212.148.187.129.079.065c.1.068.194.14.288.216l.119.1.151.126c.1.086.205.173.3.266s.187.165.277.252l.158.162c.115.115.227.23.338.36a11.938,11.938,0,0,1,2.7,4.76.425.425,0,0,0,.036.122,11.9,11.9,0,0,1,.36,4.58l-.259,2.31-.36,3.209,16.474-.133,2.842-.022,12.463-.1Z",
    transform: "translate(-7.042 -138.056)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M43.751,229.176c0,.425-.029.871-.043,1.335h0v-.241a13.47,13.47,0,0,0-2.382-8.221c-.237-.173-.486-.335-.72-.482a8.923,8.923,0,0,0-1.13-.561c-6.393-2.608-17.417-5.4-26.322.914h0a20.363,20.363,0,0,0-2.022,1.63c0-.162-.022-.3-.025-.425a.273.273,0,0,1,0-.054,4.7,4.7,0,0,0-.018-.529,20.986,20.986,0,0,1,2.119-1.716h0c8.9-6.307,19.925-3.522,26.322-.91a9.414,9.414,0,0,1,1.13.558,6.614,6.614,0,0,1,.72.486A13.438,13.438,0,0,1,43.751,229.176Z",
    transform: "translate(-7.1 -138.066)",
    fill: "#fff",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(10.52 141.378)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M197.1,399.116h-1.525l-.068-.486h.953Z",
    transform: "translate(-135.689 -395.734)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M135,393.962h-1.928l-.2-3.382h.957Z",
    transform: "translate(-95.586 -390.58)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M93.237,399.116h-1.3l-.068-.486h.953Z",
    transform: "translate(-69.337 -395.734)",
    fill: "#b44862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M31.366,393.962H29.441l-.2-3.382h.953Z",
    transform: "translate(-29.24 -390.58)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M195.917,399.116h-.338l-.068-.486Z",
    transform: "translate(-135.689 -395.734)",
    fill: "#8e344e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M92.277,399.116h-.338l-.068-.486Z",
    transform: "translate(-69.337 -395.734)",
    fill: "#8e344e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoverBanner);
export default __webpack_public_path__ + "static/media/mover_banner.2ed1eddd01575d760297515e0ae01bd7.svg";
export { ForwardRef as ReactComponent };